module.exports =
/******/
function (modules) {
  // webpackBootstrap

  /******/
  // The module cache

  /******/
  var installedModules = {};
  /******/

  /******/
  // The require function

  /******/

  function __webpack_require__(moduleId) {
    /******/

    /******/
    // Check if module is in cache

    /******/
    if (installedModules[moduleId]) {
      /******/
      return installedModules[moduleId].exports;
      /******/
    }
    /******/
    // Create a new module (and put it into the cache)

    /******/


    var module = installedModules[moduleId] = {
      /******/
      i: moduleId,

      /******/
      l: false,

      /******/
      exports: {}
      /******/

    };
    /******/

    /******/
    // Execute the module function

    /******/

    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/

    /******/
    // Flag the module as loaded

    /******/

    module.l = true;
    /******/

    /******/
    // Return the exports of the module

    /******/

    return module.exports;
    /******/
  }
  /******/

  /******/

  /******/
  // expose the modules object (__webpack_modules__)

  /******/


  __webpack_require__.m = modules;
  /******/

  /******/
  // expose the module cache

  /******/

  __webpack_require__.c = installedModules;
  /******/

  /******/
  // define getter function for harmony exports

  /******/

  __webpack_require__.d = function (exports, name, getter) {
    /******/
    if (!__webpack_require__.o(exports, name)) {
      /******/
      Object.defineProperty(exports, name, {
        enumerable: true,
        get: getter
      });
      /******/
    }
    /******/

  };
  /******/

  /******/
  // define __esModule on exports

  /******/


  __webpack_require__.r = function (exports) {
    /******/
    if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
      /******/
      Object.defineProperty(exports, Symbol.toStringTag, {
        value: 'Module'
      });
      /******/
    }
    /******/


    Object.defineProperty(exports, '__esModule', {
      value: true
    });
    /******/
  };
  /******/

  /******/
  // create a fake namespace object

  /******/
  // mode & 1: value is a module id, require it

  /******/
  // mode & 2: merge all properties of value into the ns

  /******/
  // mode & 4: return value when already ns object

  /******/
  // mode & 8|1: behave like require

  /******/


  __webpack_require__.t = function (value, mode) {
    /******/
    if (mode & 1) value = __webpack_require__(value);
    /******/

    if (mode & 8) return value;
    /******/

    if (mode & 4 && typeof value === 'object' && value && value.__esModule) return value;
    /******/

    var ns = Object.create(null);
    /******/

    __webpack_require__.r(ns);
    /******/


    Object.defineProperty(ns, 'default', {
      enumerable: true,
      value: value
    });
    /******/

    if (mode & 2 && typeof value != 'string') for (var key in value) __webpack_require__.d(ns, key, function (key) {
      return value[key];
    }.bind(null, key));
    /******/

    return ns;
    /******/
  };
  /******/

  /******/
  // getDefaultExport function for compatibility with non-harmony modules

  /******/


  __webpack_require__.n = function (module) {
    /******/
    var getter = module && module.__esModule ?
    /******/
    function getDefault() {
      return module['default'];
    } :
    /******/
    function getModuleExports() {
      return module;
    };
    /******/

    __webpack_require__.d(getter, 'a', getter);
    /******/


    return getter;
    /******/
  };
  /******/

  /******/
  // Object.prototype.hasOwnProperty.call

  /******/


  __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/

  /******/
  // __webpack_public_path__

  /******/


  __webpack_require__.p = "";
  /******/

  /******/

  /******/
  // Load entry module and return exports

  /******/

  return __webpack_require__(__webpack_require__.s = 6);
  /******/
}
/************************************************************************/

/******/
([
/* 0 */

/***/
function (module, exports) {
  module.exports = require("vue");
  /***/
},
/* 1 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  function _extends() {
    return _extends = Object.assign || function (a) {
      for (var b, c = 1; c < arguments.length; c++) for (var d in b = arguments[c], b) Object.prototype.hasOwnProperty.call(b, d) && (a[d] = b[d]);

      return a;
    }, _extends.apply(this, arguments);
  }

  var normalMerge = ["attrs", "props", "domProps"],
      toArrayMerge = ["class", "style", "directives"],
      functionalMerge = ["on", "nativeOn"],
      mergeJsxProps = function (a) {
    return a.reduce(function (c, a) {
      for (var b in a) if (!c[b]) c[b] = a[b];else if (-1 !== normalMerge.indexOf(b)) c[b] = _extends({}, c[b], a[b]);else if (-1 !== toArrayMerge.indexOf(b)) {
        var d = c[b] instanceof Array ? c[b] : [c[b]],
            e = a[b] instanceof Array ? a[b] : [a[b]];
        c[b] = d.concat(e);
      } else if (-1 !== functionalMerge.indexOf(b)) {
        for (var f in a[b]) if (c[b][f]) {
          var g = c[b][f] instanceof Array ? c[b][f] : [c[b][f]],
              h = a[b][f] instanceof Array ? a[b][f] : [a[b][f]];
          c[b][f] = g.concat(h);
        } else c[b][f] = a[b][f];
      } else if ("hook" == b) for (var i in a[b]) c[b][i] = c[b][i] ? mergeFn(c[b][i], a[b][i]) : a[b][i];else c[b] = a[b];

      return c;
    }, {});
  },
      mergeFn = function (a, b) {
    return function () {
      a && a.apply(this, arguments), b && b.apply(this, arguments);
    };
  };

  module.exports = mergeJsxProps;
  /***/
},
/* 2 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /*
    MIT License http://www.opensource.org/licenses/mit-license.php
    Author Tobias Koppers @sokra
  */
  // css base code, injected by the css-loader
  // eslint-disable-next-line func-names

  module.exports = function (useSourceMap) {
    var list = []; // return the list of modules as css string

    list.toString = function toString() {
      return this.map(function (item) {
        var content = cssWithMappingToString(item, useSourceMap);

        if (item[2]) {
          return "@media ".concat(item[2], " {").concat(content, "}");
        }

        return content;
      }).join('');
    }; // import a list of modules into the list
    // eslint-disable-next-line func-names


    list.i = function (modules, mediaQuery, dedupe) {
      if (typeof modules === 'string') {
        // eslint-disable-next-line no-param-reassign
        modules = [[null, modules, '']];
      }

      var alreadyImportedModules = {};

      if (dedupe) {
        for (var i = 0; i < this.length; i++) {
          // eslint-disable-next-line prefer-destructuring
          var id = this[i][0];

          if (id != null) {
            alreadyImportedModules[id] = true;
          }
        }
      }

      for (var _i = 0; _i < modules.length; _i++) {
        var item = [].concat(modules[_i]);

        if (dedupe && alreadyImportedModules[item[0]]) {
          // eslint-disable-next-line no-continue
          continue;
        }

        if (mediaQuery) {
          if (!item[2]) {
            item[2] = mediaQuery;
          } else {
            item[2] = "".concat(mediaQuery, " and ").concat(item[2]);
          }
        }

        list.push(item);
      }
    };

    return list;
  };

  function cssWithMappingToString(item, useSourceMap) {
    var content = item[1] || ''; // eslint-disable-next-line prefer-destructuring

    var cssMapping = item[3];

    if (!cssMapping) {
      return content;
    }

    if (useSourceMap && typeof btoa === 'function') {
      var sourceMapping = toComment(cssMapping);
      var sourceURLs = cssMapping.sources.map(function (source) {
        return "/*# sourceURL=".concat(cssMapping.sourceRoot || '').concat(source, " */");
      });
      return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
    }

    return [content].join('\n');
  } // Adapted from convert-source-map (MIT)


  function toComment(sourceMap) {
    // eslint-disable-next-line no-undef
    var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
    var data = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(base64);
    return "/*# ".concat(data, " */");
  }
  /***/

},
/* 3 */

/***/
function (module, exports, __webpack_require__) {
  var api = __webpack_require__(4);

  var content = __webpack_require__(5);

  content = content.__esModule ? content.default : content;

  if (typeof content === 'string') {
    content = [[module.i, content, '']];
  }

  var options = {};
  options.insert = "head";
  options.singleton = false;
  var update = api(content, options);
  module.exports = content.locals || {};
  /***/
},
/* 4 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var isOldIE = function isOldIE() {
    var memo;
    return function memorize() {
      if (typeof memo === 'undefined') {
        // Test for IE <= 9 as proposed by Browserhacks
        // @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
        // Tests for existence of standard globals is to allow style-loader
        // to operate correctly into non-standard environments
        // @see https://github.com/webpack-contrib/style-loader/issues/177
        memo = Boolean(window && document && document.all && !window.atob);
      }

      return memo;
    };
  }();

  var getTarget = function getTarget() {
    var memo = {};
    return function memorize(target) {
      if (typeof memo[target] === 'undefined') {
        var styleTarget = document.querySelector(target); // Special case to return head of iframe instead of iframe itself

        if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
          try {
            // This will throw an exception if access to iframe is blocked
            // due to cross-origin restrictions
            styleTarget = styleTarget.contentDocument.head;
          } catch (e) {
            // istanbul ignore next
            styleTarget = null;
          }
        }

        memo[target] = styleTarget;
      }

      return memo[target];
    };
  }();

  var stylesInDom = [];

  function getIndexByIdentifier(identifier) {
    var result = -1;

    for (var i = 0; i < stylesInDom.length; i++) {
      if (stylesInDom[i].identifier === identifier) {
        result = i;
        break;
      }
    }

    return result;
  }

  function modulesToDom(list, options) {
    var idCountMap = {};
    var identifiers = [];

    for (var i = 0; i < list.length; i++) {
      var item = list[i];
      var id = options.base ? item[0] + options.base : item[0];
      var count = idCountMap[id] || 0;
      var identifier = "".concat(id, " ").concat(count);
      idCountMap[id] = count + 1;
      var index = getIndexByIdentifier(identifier);
      var obj = {
        css: item[1],
        media: item[2],
        sourceMap: item[3]
      };

      if (index !== -1) {
        stylesInDom[index].references++;
        stylesInDom[index].updater(obj);
      } else {
        stylesInDom.push({
          identifier: identifier,
          updater: addStyle(obj, options),
          references: 1
        });
      }

      identifiers.push(identifier);
    }

    return identifiers;
  }

  function insertStyleElement(options) {
    var style = document.createElement('style');
    var attributes = options.attributes || {};

    if (typeof attributes.nonce === 'undefined') {
      var nonce = true ? __webpack_require__.nc : undefined;

      if (nonce) {
        attributes.nonce = nonce;
      }
    }

    Object.keys(attributes).forEach(function (key) {
      style.setAttribute(key, attributes[key]);
    });

    if (typeof options.insert === 'function') {
      options.insert(style);
    } else {
      var target = getTarget(options.insert || 'head');

      if (!target) {
        throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
      }

      target.appendChild(style);
    }

    return style;
  }

  function removeStyleElement(style) {
    // istanbul ignore if
    if (style.parentNode === null) {
      return false;
    }

    style.parentNode.removeChild(style);
  }
  /* istanbul ignore next  */


  var replaceText = function replaceText() {
    var textStore = [];
    return function replace(index, replacement) {
      textStore[index] = replacement;
      return textStore.filter(Boolean).join('\n');
    };
  }();

  function applyToSingletonTag(style, index, remove, obj) {
    var css = remove ? '' : obj.media ? "@media ".concat(obj.media, " {").concat(obj.css, "}") : obj.css; // For old IE

    /* istanbul ignore if  */

    if (style.styleSheet) {
      style.styleSheet.cssText = replaceText(index, css);
    } else {
      var cssNode = document.createTextNode(css);
      var childNodes = style.childNodes;

      if (childNodes[index]) {
        style.removeChild(childNodes[index]);
      }

      if (childNodes.length) {
        style.insertBefore(cssNode, childNodes[index]);
      } else {
        style.appendChild(cssNode);
      }
    }
  }

  function applyToTag(style, options, obj) {
    var css = obj.css;
    var media = obj.media;
    var sourceMap = obj.sourceMap;

    if (media) {
      style.setAttribute('media', media);
    } else {
      style.removeAttribute('media');
    }

    if (sourceMap && typeof btoa !== 'undefined') {
      css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
    } // For old IE

    /* istanbul ignore if  */


    if (style.styleSheet) {
      style.styleSheet.cssText = css;
    } else {
      while (style.firstChild) {
        style.removeChild(style.firstChild);
      }

      style.appendChild(document.createTextNode(css));
    }
  }

  var singleton = null;
  var singletonCounter = 0;

  function addStyle(obj, options) {
    var style;
    var update;
    var remove;

    if (options.singleton) {
      var styleIndex = singletonCounter++;
      style = singleton || (singleton = insertStyleElement(options));
      update = applyToSingletonTag.bind(null, style, styleIndex, false);
      remove = applyToSingletonTag.bind(null, style, styleIndex, true);
    } else {
      style = insertStyleElement(options);
      update = applyToTag.bind(null, style, options);

      remove = function remove() {
        removeStyleElement(style);
      };
    }

    update(obj);
    return function updateStyle(newObj) {
      if (newObj) {
        if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) {
          return;
        }

        update(obj = newObj);
      } else {
        remove();
      }
    };
  }

  module.exports = function (list, options) {
    options = options || {}; // Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
    // tags it will allow on a page

    if (!options.singleton && typeof options.singleton !== 'boolean') {
      options.singleton = isOldIE();
    }

    list = list || [];
    var lastIdentifiers = modulesToDom(list, options);
    return function update(newList) {
      newList = newList || [];

      if (Object.prototype.toString.call(newList) !== '[object Array]') {
        return;
      }

      for (var i = 0; i < lastIdentifiers.length; i++) {
        var identifier = lastIdentifiers[i];
        var index = getIndexByIdentifier(identifier);
        stylesInDom[index].references--;
      }

      var newLastIdentifiers = modulesToDom(newList, options);

      for (var _i = 0; _i < lastIdentifiers.length; _i++) {
        var _identifier = lastIdentifiers[_i];

        var _index = getIndexByIdentifier(_identifier);

        if (stylesInDom[_index].references === 0) {
          stylesInDom[_index].updater();

          stylesInDom.splice(_index, 1);
        }
      }

      lastIdentifiers = newLastIdentifiers;
    };
  };
  /***/

},
/* 5 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  __webpack_require__.r(__webpack_exports__);
  /* harmony import */


  var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
  /* harmony import */


  var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__); // Imports


  var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default()(false); // Module


  ___CSS_LOADER_EXPORT___.push([module.i, "/* recommended css code for vue-svgicon */\n.meg-icon {\n  display: inline-block;\n  width: 1em;\n  height: 1em;\n  color: inherit;\n  vertical-align: middle;\n  fill: none;\n  stroke: currentColor;\n}\n.meg-fill {\n  fill: currentColor;\n  stroke: none;\n}\n.meg-icon--right {\n  margin-left: 5px;\n}\n.vue-svg-icon-up {\n  /* default */\n  transform: rotate(0deg);\n}\n.vue-svg-icon-right {\n   transform: rotate(90deg);\n}\n.vue-svg-icon-down {\n  transform: rotate(180deg);\n}\n.vue-svg-icon-left {\n  transform: rotate(-90deg);\n}\n@keyframes rotating {\n  0% {\n    transform: rotateZ(0deg);\n  }\n  100% {\n    transform: rotateZ(360deg);\n  }\n}", ""]); // Exports

  /* harmony default export */


  __webpack_exports__["default"] = ___CSS_LOADER_EXPORT___;
  /***/
},
/* 6 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict"; // ESM COMPAT FLAG

  __webpack_require__.r(__webpack_exports__); // EXTERNAL MODULE: external {"root":"Vue","commonjs2":"vue","commonjs":"vue","amd":"vue"}


  var external_root_Vue_commonjs2_vue_commonjs_vue_amd_vue_ = __webpack_require__(0);

  var external_root_Vue_commonjs2_vue_commonjs_vue_amd_vue_default = /*#__PURE__*/__webpack_require__.n(external_root_Vue_commonjs2_vue_commonjs_vue_amd_vue_); // EXTERNAL MODULE: /Users/luokaihui/Documents/work/megvii-icons/node_modules/@vue/babel-helper-vue-jsx-merge-props/dist/helper.js


  var helper = __webpack_require__(1);

  var helper_default = /*#__PURE__*/__webpack_require__.n(helper); // CONCATENATED MODULE: ./src/lib/SvgIcon.jsx


  var icons = {};
  var notLoadedIcons = [];
  var defaultWidth = '';
  var defaultHeight = '';
  var tagName = 'svg-icon';
  var classPrefix = 'svg-icon';
  var isStroke = false;
  var isOriginalDefault = false;
  var defaultIcon = {
    width: 1,
    height: 1,
    viewBox: '0 0 1 1',
    data: '<rect width="0" height="0"/>'
  };

  function register(data) {
    var _loop = function _loop(name) {
      if (!icons[name]) {
        icons[name] = data[name];
      } // check new register icon is not loaded, and set loaded to true


      notLoadedIcons = notLoadedIcons.filter(function (v) {
        if (v.name === name) {
          v.component.$set(v.component, 'loaded', true);
        }

        return v.name !== name;
      });
    };

    for (var name in data) {
      _loop(name);
    }
  }
  /* harmony default export */


  var SvgIcon = {
    data: function data() {
      return {
        loaded: false,
        registerSvgData: {}
      };
    },
    props: {
      dir: String,
      component: Object,
      rotate: Number,
      spin: Boolean,
      icon: String,
      name: String,
      width: {
        type: String,
        default: defaultWidth
      },
      height: {
        type: String,
        default: defaultHeight
      },
      size: {
        type: String,
        default: defaultWidth
      },
      scale: Number,
      fill: {
        type: Boolean,
        default: function _default() {
          return !isStroke;
        }
      },
      color: String,
      original: {
        type: Boolean,
        default: function _default() {
          return isOriginalDefault;
        }
      },
      title: String,
      svgData: Object
    },
    computed: {
      clazz: function clazz() {
        var clazz = "".concat(classPrefix, "-icon");

        if (this.fill) {
          clazz += " ".concat(classPrefix, "-fill");
        }

        if (this.dir) {
          clazz += " vue-svg-icon-".concat(this.dir);
        }

        return clazz;
      },
      iconName: function iconName() {
        var iconName = this.name || this.icon || '';
        var prefix = "".concat(tagName, "-");
        return iconName.startsWith(prefix) ? iconName.replace(prefix, '') : iconName;
      },
      iconData: function iconData() {
        if (this.component) {
          return this.registerSvgData;
        }

        var iconData = icons[this.iconName] || this.svgData || defaultIcon;

        if (iconData || this.loaded) {
          return iconData;
        }

        return null;
      },
      colors: function colors() {
        if (this.color) {
          return this.color.split(' ');
        }

        return [];
      },
      path: function path() {
        var pathData = '';

        if (this.iconData) {
          pathData = this.iconData.data;
          pathData = this.setTitle(pathData); // use original color

          if (this.original) {
            pathData = this.addOriginalColor(pathData);
          }

          if (this.colors.length > 0) {
            pathData = this.addColor(pathData);
          }
        } else {
          // if no iconData, push to notLoadedIcons
          notLoadedIcons.push({
            name: this.iconName,
            component: this
          });
        }

        return this.getValidPathData(pathData);
      },
      box: function box() {
        var width = this.width;
        var height = this.width;

        if (this.component) {
          return "0 0 ".concat(this.registerSvgData.width, " ").concat(this.registerSvgData.height);
        } else if (this.iconData) {
          if (this.iconData.viewBox) {
            return this.iconData.viewBox;
          }

          return "0 0 ".concat(this.iconData.width, " ").concat(this.iconData.height);
        }

        return "0 0 ".concat(parseFloat(width), " ").concat(parseFloat(height));
      },
      style: function style() {
        var rotate = Number(this.rotate) || 0;
        var digitReg = /^\d+$/;
        var scale = Number(this.scale);
        var width;
        var height; // apply scale

        if (!isNaN(scale)) {
          if (this.component) {
            width = this.registerSvgData.width;
            height = this.registerSvgData.height;
          } else if (this.iconData) {
            width = this.iconData.width;
            height = this.iconData.height;
          }

          width = Number(width) * scale + 'px';
          height = Number(height) * scale + 'px';
        } else {
          width = digitReg.test(this.width) ? this.width + 'px' : this.width || defaultWidth;
          height = digitReg.test(this.height) ? this.height + 'px' : this.height || defaultWidth;
        }

        var style = {};

        if (width) {
          style.width = width;
        }

        if (height) {
          style.height = height;
        }

        if (this.spin) {
          style.animation = 'rotating 2s linear infinite';
        }

        if (rotate) {
          style.transform = "rotate(".concat(rotate, "deg)");
        }

        return style;
      }
    },
    watch: {
      component: {
        handler: function handler(component) {
          if (component) {
            // functional component
            var uid = "inline-component-".concat(this._uid);
            external_root_Vue_commonjs2_vue_commonjs_vue_amd_vue_default.a.component(uid, component);
            var res = external_root_Vue_commonjs2_vue_commonjs_vue_amd_vue_default.a.compile("<".concat(uid, " />"));
            var svg = new external_root_Vue_commonjs2_vue_commonjs_vue_amd_vue_default.a({
              render: res.render,
              staticRenderFns: res.staticRenderFns
            }).$mount();
            var el = svg.$el;
            var viewBox = el.getAttribute('viewBox') || '';
            var viewAttrs = viewBox.split(/\s/);
            this.registerSvgData = {
              width: el.getAttribute('width') || viewAttrs[2] || 50,
              height: el.getAttribute('height') || viewAttrs[3] || 50,
              viewBox: el.getAttribute('viewBox'),
              data: svg.$el.innerHTML
            };
            delete external_root_Vue_commonjs2_vue_commonjs_vue_amd_vue_default.a.options.components[uid];
            svg.$destroy();
          }
        },
        immediate: true
      }
    },
    created: function created() {
      if (icons[this.iconName]) {
        this.loaded = true;
      }
    },
    methods: {
      addColor: function addColor(data) {
        var _this = this;

        var reg = /<(path|rect|circle|polygon|line|polyline|ellipse)\s/gi;
        var i = 0;
        return data.replace(reg, function (match) {
          var color = _this.colors[i++] || _this.colors[_this.colors.length - 1];
          var fill = _this.fill; // if color is '_', ignore it

          if (color && color === '_') {
            return match;
          } // if color start with 'r-', reverse the fill value


          if (color && color.indexOf('r-') === 0) {
            fill = !fill;
            color = color.split('r-')[1];
          }

          var style = fill ? 'fill' : 'stroke';
          var reverseStyle = fill ? 'stroke' : 'fill';
          return match + "".concat(style, "=\"").concat(color, "\" ").concat(reverseStyle, "=\"none\" ");
        });
      },
      addOriginalColor: function addOriginalColor(data) {
        var styleReg = /_fill="|_stroke="/gi;
        return data.replace(styleReg, function (styleName) {
          return styleName && styleName.slice(1);
        });
      },
      getValidPathData: function getValidPathData(pathData) {
        // If use original and colors, clear double fill or stroke
        if (this.original && this.colors.length > 0) {
          var reg = /<(path|rect|circle|polygon|line|polyline|ellipse)(\sfill|\sstroke)([="\w\s\.\-\+#\$\&>]+)(fill|stroke)/gi;
          pathData = pathData.replace(reg, function (match, p1, p2, p3, p4) {
            return "<".concat(p1).concat(p2).concat(p3, "_").concat(p4);
          });
        }

        return pathData;
      },
      setTitle: function setTitle(pathData) {
        if (this.title) {
          var title = this.title.replace(/\</gi, '&lt;').replace(/>/gi, '&gt;').replace(/&/g, '&amp;');
          return "<title>".concat(title, "</title>") + pathData;
        }

        return pathData;
      },
      onClick: function onClick(e) {
        this.$emit('click', e);
      }
    },
    install: function install(Vue) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      tagName = options.tagName || 'meg-icon';

      if (options.classPrefix) {
        classPrefix = options.classPrefix;
      }

      isStroke = !!options.isStroke;
      isOriginalDefault = !!options.isOriginalDefault; // default size

      options.defaultWidth && (defaultWidth = options.defaultWidth);
      options.defaultHeight && (defaultHeight = options.defaultHeight);
      Vue.component(tagName, this);
    },
    // register icons
    register: register,
    icons: icons,
    render: function render() {
      var h = arguments[0];
      var path = this.path,
          iconName = this.iconName,
          clazz = this.clazz,
          box = this.box,
          style = this.style,
          onClick = this.onClick;
      var svgProps = {
        domProps: {
          innerHTML: path
        }
      };
      return path ? h("svg", helper_default()([{}, svgProps, {
        "attrs": {
          "data-svg-icon": iconName,
          "viewBox": box
        },
        "class": clazz,
        "style": style,
        "on": {
          "click": onClick
        }
      }])) : null;
    }
  }; // CONCATENATED MODULE: ./src/index.jsx

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  if (!external_root_Vue_commonjs2_vue_commonjs_vue_amd_vue_default.a.prototype.$isServer) {
    __webpack_require__(3);
  }

  var VueIconPlugin = {
    install: function install(Vue, opts) {
      if (!opts) opts = {};
      if (VueIconPlugin.install.installed) return;
      /**
       * 注册所有的图标
       * _svgIcons: {
       *  iconA: {
       *      name: "icon3",
       *      data: "<g fill="none" fill-rule="evenodd"><g><rect pid="0" fill="#0E57A2",
       *      viewBox: "0 0 78 78",
       *      width: 78,
       *      height: 78
       *   }
       * }
       */

      var $$$ = {
        "megui-eye-invisible": {
          "name": "megui-eye-invisible",
          "data": "<path pid=\"0\" d=\"M15.5 7.8c-.7-1.4-1.4-2.5-2.3-3.3l-.9.9c.8.7 1.5 1.7 2 2.9-1.5 3.1-3.6 4.6-6.5 4.6-.9 0-1.8-.1-2.5-.4l-1 1c1 .5 2.2.8 3.5.8 3.4 0 6-1.8 7.7-5.4.2-.5.2-.9 0-1.1zm-1.1-6l-.8-.8h-.2l-2.1 2.1c-1-.5-2.2-.8-3.5-.8-3.4 0-6 1.8-7.7 5.4-.1.3-.1.7 0 1 .7 1.4 1.4 2.5 2.3 3.3L.6 13.8c-.1.1-.1.1 0 .2l.8.8c.1.1.1.1.2 0L14.4 2v-.2zM5.8 8.7c0-.1-.1-.3-.1-.5 0-1.1.9-2 2-2 .2 0 .3 0 .5.1L5.8 8.7zm3.3-3.3c-.4-.2-.9-.3-1.4-.3-1.7 0-3.1 1.4-3.1 3.1 0 .5.1.9.3 1.4l-1.5 1.5c-.8-.7-1.5-1.7-2-2.9C2.9 5.1 5 3.6 7.9 3.6c.9 0 1.8.1 2.5.4L9.1 5.4zm-1.4 4.8h-.3l-.9.9c.4.2.8.3 1.3.3 1.7 0 3.2-1.4 3.2-3.2 0-.4-.1-.9-.3-1.3l-1 1v.3c0 1.1-.9 2-2 2z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#181725\" fill-opacity=\".6\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "megui-eye": {
          "name": "megui-eye",
          "data": "<path pid=\"0\" d=\"M8 2c3.5 0 6.2 1.8 7.9 5.4l.1.2-.2.5c-1.5 3.4-4.1 5.2-7.6 5.3-3.6.1-6.3-1.8-8.1-5.6L0 7.6l.3-.5C2 3.7 4.6 2 8 2zm0 1.2c-2.8 0-5.3 1.7-6.7 4.6l.1-.2.2.4c1.4 2.6 3.7 4.2 6.2 4.3h.6c2.9-.1 5.2-1.8 6.4-4.7v.2-.1c-1.6-2.7-4-4.4-6.5-4.5H8zM7.9 5c1.6 0 2.9 1.3 2.9 2.9s-1.3 2.9-2.9 2.9S5 9.4 5 7.9 6.3 5 7.9 5zm0 1C6.8 6 6 6.8 6 7.9s.9 1.9 1.9 1.9 1.9-.9 1.9-1.9S8.9 6 7.9 6z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#181725\" fill-opacity=\".6\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "select-Normal": {
          "name": "select-Normal",
          "data": "<path pid=\"0\" d=\"M8 0h-.2C3.4.1 0 3.7 0 8c0 4.4 3.6 8 8 8h.2c4.3-.1 7.8-3.7 7.8-8v-.2C15.9 3.4 12.3 0 8 0zm-.2.9H8c3.8 0 6.9 3 7.1 6.8v.2c0 3.8-3 6.9-6.8 7h-.2C4.2 14.9 1 11.7 1 7.8.9 4.2 4 1.1 7.8.9z\" _fill=\"#181725\" fill-opacity=\".2\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "form": {
          "name": "form",
          "data": "<path pid=\"0\" d=\"M12 1.4c.9 0 1.6.7 1.6 1.6v8.4l-4.3 3.2H4c-.9 0-1.6-.7-1.6-1.6V3c0-.9.7-1.6 1.6-1.6h8zm0 1.2H4c-.2 0-.4.2-.4.4v10c0 .2.2.4.4.4h4.9l3.5-2.6V3c0-.2-.1-.4-.4-.4zM9 7.9v1.2H4.8V7.9H9zm2.2-2v1.2H4.8V5.9h6.4zm0-2v1.2H4.8V3.9h6.4z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#181725\" fill-opacity=\".6\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "megui-filter": {
          "name": "megui-filter",
          "data": "<path pid=\"0\" d=\"M3.1 2.4H3C1.6 2.5.9 4 1.8 5.1l4 5.2v3.6c0 .4.4.7.8.6l2.6-1.1.1-.1c.5-.3.8-.9.8-1.5v-1.5l4-5.2c.9-1.1.1-2.7-1.3-2.7H3.1zm0 1.2h9.8c.4 0 .6.5.4.8L9.2 9.7c-.1.1-.2.3-.2.4v1.8c0 .2-.1.3-.3.4L7 13v-2.9c0-.1 0-.3-.1-.4L2.7 4.4c-.2-.3 0-.8.4-.8z\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "select-active": {
          "name": "select-active",
          "data": "<path pid=\"0\" d=\"M8 0c4.3 0 7.9 3.5 8 7.8V8c0 4.3-3.5 7.9-7.8 8H8c-4.4 0-8-3.6-8-8C0 3.7 3.5.1 7.8 0H8zm0 1h-.2C4 1.1 1 4.2 1 8s3 6.9 6.7 7h.5c3.7-.1 6.7-3.1 6.8-6.7v-.5c-.1-3.7-3.1-6.7-6.8-6.8H8z\" _fill=\"#1067d1\"/><circle pid=\"1\" cx=\"8\" cy=\"8\" r=\"4\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#1067d1\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "megui-right-loading": {
          "name": "megui-right-loading",
          "data": "<g fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#181725\" fill-opacity=\".6\"><path pid=\"0\" d=\"M4.7 3.7l4.1 4.1c.2.2.2.5 0 .7v.1l-4 4c-.1.1-.2.1-.3.2v-1.6l3-3-3-3V3.6s.1.1.2.1z\"/><path pid=\"1\" d=\"M8.7 3.7l4.1 4.1c.2.2.2.5 0 .7v.1l-4 4c-.1.1-.2.1-.3.2v-1.6l3-3-3-3V3.6s.1.1.2.1z\"/></g>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "Check": {
          "name": "Check",
          "data": "<path pid=\"0\" d=\"M14.7 3l-7.6 9.7c-.2.2-.5.3-.7.1l-.1-.1L2 7.3h1.6l3.1 3.9L13.1 3h1.6z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#181725\" fill-opacity=\".6\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "cloud": {
          "name": "cloud",
          "data": "<path pid=\"0\" d=\"M8 3.4c2.2 0 4.1 1.6 4.4 3.8v.2c1.2.4 2.1 1.4 2.2 2.7v.2c0 1.7-1.4 3.1-3.1 3.1h-7c-1.7 0-3.1-1.4-3.1-3.1 0-1.4.9-2.6 2.2-2.9v-.2c.3-2.1 2-3.7 4.2-3.8H8zm0 1.2c-1.6 0-2.9 1.1-3.2 2.6h1c.3 0 .6.3.6.6s-.2.5-.5.6H4.3h-.1c-.9.1-1.6.9-1.6 1.8 0 1 .8 1.9 1.9 1.9h7.1c1 0 1.9-.8 1.9-1.9 0-.9-.7-1.7-1.6-1.8-.3 0-.6-.3-.5-.6v-.2c-.1-1.6-1.4-2.9-3-3H8z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#181725\" fill-opacity=\".6\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "layout": {
          "name": "layout",
          "data": "<path pid=\"0\" d=\"M7.8 10c.1 0 .2.1.2.2v3.6c0 .1-.1.2-.2.2H2.2c-.1 0-.2-.1-.2-.2v-3.6c0-.1.1-.2.2-.2h5.6zm6-2c.1 0 .2.1.2.2v5.6c0 .1-.1.2-.2.2H9.2c-.1 0-.2-.1-.2-.2V8.2c0-.1.1-.2.2-.2h4.6zM7 11H3v2h4v-2zm5.8-1.8h-2.6v3.6h2.6V9.2zM7.8 2c.1 0 .2.1.2.2v6.6c0 .1-.1.2-.2.2H2.2c-.1 0-.2-.1-.2-.2V2.2c0-.1.1-.2.2-.2h5.6zm-1 1.2H3.2v4.6h3.6V3.2zm7-1.2c.1 0 .2.1.2.2v4.6c0 .1-.1.2-.2.2H9.2c-.1 0-.2-.1-.2-.2V2.2c0-.1.1-.2.2-.2h4.6zm-1 1.2h-2.6v2.6h2.6V3.2z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#181725\" fill-opacity=\".6\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "select-hover": {
          "name": "select-hover",
          "data": "<path pid=\"0\" d=\"M8 0c4.3 0 7.9 3.5 8 7.8V8c0 4.3-3.5 7.9-7.8 8H8c-4.4 0-8-3.6-8-8C0 3.7 3.5.1 7.8 0H8zm0 1h-.2C4 1.1 1 4.2 1 8s3 6.9 6.7 7h.5c3.7-.1 6.7-3.1 6.8-6.7v-.5c-.1-3.7-3.1-6.7-6.8-6.8H8z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#3e83d8\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "select-disabled": {
          "name": "select-disabled",
          "data": "<circle pid=\"0\" cx=\"8\" cy=\"8\" r=\"4\" opacity=\".8\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#d1d1d3\"/><path pid=\"1\" d=\"M8 0h-.2C3.4.1 0 3.7 0 8c0 4.4 3.6 8 8 8h.2c4.3-.1 7.8-3.7 7.8-8v-.2C15.9 3.4 12.3 0 8 0zm-.2.9H8c3.8 0 6.9 3 7.1 6.8v.2c0 3.8-3 6.9-6.8 7h-.2C4.2 14.9 1 11.7 1 7.8.9 4.2 4 1.1 7.8.9z\" _fill=\"#181725\" fill-opacity=\".2\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "date": {
          "name": "date",
          "data": "<path pid=\"0\" d=\"M5 0v2h6V0h1v2h3c.6 0 1 .4 1 1v12c0 .6-.4 1-1 1H1c-.6 0-1-.4-1-1V3c0-.6.4-1 1-1h3V0h1zm10 7H1v8h14V7zM4 3H1v3h14V3h-3v2h-1V3H5v2H4V3z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#181725\" fill-opacity=\".6\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "refresh": {
          "name": "refresh",
          "data": "<path pid=\"0\" d=\"M15.3 2.5l-1 .8c-1.4-1.8-3.6-3-6.1-3C3.9.3.5 3.7.5 8c0 4.2 3.4 7.7 7.7 7.7 3.3 0 6.1-2.1 7.2-5 0-.1 0-.2-.1-.2l-1-.4c-.1 0-.2 0-.2.1s-.1.2-.1.3c-.3.7-.8 1.4-1.3 2-.6.6-1.3 1-2 1.3-.8.3-1.6.5-2.4.5-.9 0-1.7-.2-2.4-.5s-1.4-.8-2-1.3c-.6-.6-1-1.3-1.3-2-.5-.8-.7-1.7-.7-2.5s.2-1.7.5-2.4.8-1.4 1.3-2 1.3-1 2-1.3c.8-.3 1.6-.5 2.4-.5.9 0 1.7.2 2.4.5s1.4.8 2 1.3c.2.2.4.4.5.6L12 5c-.1.1-.1.2.1.3l3.2.7c.1 0 .2 0 .2-.1V2.6c0-.1-.1-.2-.2-.1z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#181725\" fill-opacity=\".6\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "adddd": {
          "name": "adddd",
          "data": "<path pid=\"0\" d=\"M8 0c4.4 0 8 3.6 8 8s-3.6 8-8 8-8-3.6-8-8 3.6-8 8-8zm0 1C4.1 1 1 4.1 1 8s3.1 7 7 7 7-3.1 7-7-3.1-7-7-7zm.4 2.5c.1 0 .1 0 .1.1v3.9h3.9c.1 0 .1 0 .1.1v.8c0 .1 0 .1-.1.1H8.5v3.9c0 .1 0 .1-.1.1h-.8c-.1 0-.1 0-.1-.1V8.5H3.6c-.1 0-.1 0-.1-.1v-.8c0-.1 0-.1.1-.1h3.9V3.6c0-.1 0-.1.1-.1h.8z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#181725\" fill-opacity=\".6\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "megui-user": {
          "name": "megui-user",
          "data": "<path pid=\"0\" d=\"M13.2 12c-.3-.7-.7-1.3-1.3-1.9s-1.2-1-1.9-1.3c1-.7 1.6-1.8 1.6-3.1 0-2.1-1.7-3.9-3.9-3.9S3.9 3.6 3.9 5.7c0 1.3.6 2.4 1.6 3.1-.7.3-1.3.7-1.9 1.3-.5.5-1 1.2-1.3 1.9-.3.7-.4 1.4-.5 2.2 0 .1.1.1.1.1H3c.1 0 .1-.1.1-.1 0-1.2.5-2.3 1.4-3.2.9-.9 2.1-1.4 3.3-1.4s2.4.5 3.3 1.4c.9.9 1.3 2 1.4 3.2 0 .1.1.1.1.1h.9c.1 0 .1-.1.1-.1 0-.8-.1-1.5-.4-2.2zM7.8 8.4a2.732 2.732 0 01-2.7-2.7c0-.7.3-1.4.8-1.9S7.1 3 7.8 3s1.4.3 1.9.8.8 1.2.8 1.9a2.732 2.732 0 01-2.7 2.7z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#181725\" fill-opacity=\".6\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "txt": {
          "name": "txt",
          "data": "<path pid=\"0\" d=\"M9.6 1L14 5.4V13c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V2c0-.6.4-1 1-1h6.6zm-.9 1H3v11c0 .5.4.9.9 1H12c.5 0 .9-.4 1-.9V6.3h-2.8c-.8 0-1.5-.6-1.5-1.3V2zm3.2 9v1H4.1v-1h7.8zm0-2.5v1H4.1v-1h7.8zM7.5 6v1H4.1V6h3.4zm5-.7L9.7 2.4v2.4c0 .2.2.4.4.5h2.4z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#181725\" fill-opacity=\".6\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "question": {
          "name": "question",
          "data": "<path pid=\"0\" d=\"M8 0c4.4 0 8 3.6 8 8s-3.6 8-8 8-8-3.6-8-8 3.6-8 8-8zm0 1C4.1 1 1 4.1 1 8s3.1 7 7 7 7-3.1 7-7-3.1-7-7-7zm0 10.5c.2 0 .4.1.6.2.2.2.2.4.2.6 0 .3-.1.4-.3.6-.2.2-.4.2-.6.2-.2 0-.4-.1-.6-.2-.2-.2-.2-.4-.2-.6s.1-.4.2-.6c.2-.1.4-.2.7-.2zM8.2 3c.9 0 1.6.2 2.2.7.5.5.8 1.1.8 2 0 .6-.2 1.2-.5 1.6-.1.2-.5.5-1.1 1.1-.5.3-.7.5-.8.8-.2.3-.3.6-.3 1v.3H7.4v-.3c0-.5.1-.9.3-1.2.2-.4.7-1 1.4-1.6l.5-.5c.2-.4.4-.7.4-1.1 0-.6-.2-1-.5-1.3-.3-.4-.8-.5-1.4-.5-.7 0-1.2.2-1.5.7-.3.4-.5.9-.5 1.6H5c0-1 .3-1.8.8-2.4.6-.6 1.4-.9 2.4-.9z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#181725\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "decrease": {
          "name": "decrease",
          "data": "<path pid=\"0\" d=\"M8 0c4.4 0 8 3.6 8 8s-3.6 8-8 8-8-3.6-8-8 3.6-8 8-8zm0 1C4.1 1 1 4.1 1 8s3.1 7 7 7 7-3.1 7-7-3.1-7-7-7zm4.4 6.5c.1 0 .1 0 .1.1v.8c0 .1 0 .1-.1.1H3.6c-.1 0-.1 0-.1-.1v-.8c0-.1 0-.1.1-.1h8.8z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#181725\" fill-opacity=\".6\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "data": {
          "name": "data",
          "data": "<path pid=\"0\" d=\"M1 13.6v-1.2h1.4V8.2c0-.4.3-.7.7-.8H4.8c.4 0 .8.4.8.8v4.2h.8V3.2c0-.4.3-.7.7-.8H8.8c.4 0 .8.4.8.8v9.2h.8V6.2c0-.4.3-.7.7-.8H12.8c.4 0 .8.4.8.8v6.2H15v1.2H1zm3.4-5h-.8v3.8h.8V8.6zm4-5h-.8v8.8h.8V3.6zm4 3h-.8v5.8h.8V6.6z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#181725\" fill-opacity=\".6\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "megui-close": {
          "name": "megui-close",
          "data": "<path pid=\"0\" d=\"M3.758 2.923l.083.07L8 7.15l4.16-4.159a.6.6 0 01.917.766l-.07.083L8.848 8l4.16 4.16a.6.6 0 01-.765.917l-.083-.07L8 8.848l-4.158 4.16a.6.6 0 01-.918-.765l.07-.083L7.15 8 2.992 3.842a.6.6 0 01.766-.918z\" _fill=\"#707078\" fill-rule=\"evenodd\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "megui-info": {
          "name": "megui-info",
          "data": "<path pid=\"0\" d=\"M8 1c3.9 0 7 3.1 7 7s-3.1 7-7 7-7-3.1-7-7 3.1-7 7-7zm0 1.2C4.8 2.2 2.2 4.8 2.2 8s2.6 5.8 5.8 5.8 5.8-2.6 5.8-5.8S11.2 2.2 8 2.2zm0 7.6c.5 0 .9.4.9.9s-.4.9-.9.9-.9-.4-.9-.9.4-.9.9-.9zm0-5.3c.3 0 .5.2.6.5v3.7c0 .3-.3.5-.6.5s-.5-.2-.6-.5V5c0-.3.3-.5.6-.5z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#707078\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "megui-check-circle": {
          "name": "megui-check-circle",
          "data": "<path pid=\"0\" d=\"M8 1c3.9 0 7 3.1 7 7s-3.1 7-7 7-7-3.1-7-7 3.1-7 7-7zm0 1.2C4.8 2.2 2.2 4.8 2.2 8s2.6 5.8 5.8 5.8 5.8-2.6 5.8-5.8S11.2 2.2 8 2.2zm2.9 3.5c.1 0 .1.1.1.2l-3.2 4.4c-.2.3-.6.3-.8 0L5.1 7.7c-.1-.1 0-.2.1-.2h.7c.2 0 .3.1.4.2l1.1 1.5 2.4-3.3c.1-.1.2-.2.4-.2h.7z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#707078\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "minus": {
          "name": "minus",
          "data": "<path pid=\"0\" d=\"M12.2 7.3c.4 0 .8.3.8.7 0 .3-.3.6-.7.7H3.8c-.4 0-.8-.3-.8-.7 0-.3.3-.6.7-.7h8.5z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#707078\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "megui-dropdown": {
          "name": "megui-dropdown",
          "data": "<path pid=\"0\" id=\"\u8DEF\u5F84\" d=\"M2.3 4.5c-.3.3-.3.5-.1.8v.1l5.3 6c.3.2.6.2.9 0l.1-.1 5.3-6c.2-.2.2-.6 0-.8s-.6-.2-.8 0l-.1.1L8 10.1 3.1 4.5c-.2-.2-.5-.2-.8 0z\" _fill=\"#75747d\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "megui-right": {
          "name": "megui-right",
          "data": "<path pid=\"0\" _fill=\"#181725\" fill-opacity=\".01\" d=\"M0 0h16v16H0z\"/><path pid=\"1\" d=\"M4.6 2.3c.2-.3.5-.3.7-.1h.1l6 5.3c.2.2.3.6.1.8l-.1.1-6 5.3c-.2.2-.6.2-.8 0-.2-.2-.2-.6 0-.8l.1-.1L10.1 8 4.6 3.1c-.2-.2-.3-.5 0-.8z\" _fill=\"#75747d\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "megui-left": {
          "name": "megui-left",
          "data": "<path pid=\"0\" _fill=\"#181725\" fill-opacity=\".01\" d=\"M0 0h16v16H0z\"/><path pid=\"1\" d=\"M11.1 2.3c-.2-.3-.5-.3-.8-.1h-.1l-6 5.3c-.2.3-.2.6 0 .9l.1.1 6 5.3c.2.2.6.2.8 0 .2-.2.2-.6 0-.8l-.1-.1L5.6 8l5.5-4.9c.2-.2.2-.5 0-.8z\" _fill=\"#75747d\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "filter": {
          "name": "filter",
          "data": "<path pid=\"0\" d=\"M4 3h7.745a1 1 0 01.952 1.305l-1.568 4.9a.5.5 0 01-.476.348h-5.56a.5.5 0 01-.477-.348l-1.568-4.9A1 1 0 014 3zm1.096 7.208h5.553a.5.5 0 01.5.5v2.277a.5.5 0 01-.5.5H5.096a.5.5 0 01-.5-.5v-2.277a.5.5 0 01.5-.5z\" _fill=\"#181725\" fill-rule=\"evenodd\" opacity=\".6\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "email": {
          "name": "email",
          "data": "<path pid=\"0\" d=\"M13 3.4c.9 0 1.6.7 1.6 1.6v7c0 .9-.7 1.6-1.6 1.6H3c-.9 0-1.6-.7-1.6-1.6V5c0-.9.7-1.6 1.6-1.6h10zm-10.4 2V12c0 .2.2.4.4.4h10c.2 0 .4-.2.4-.4V5.5L8 8.7 2.6 5.4zm10-.8H3.7L8 7.3l4.6-2.7z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#181725\" fill-opacity=\".6\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "heart": {
          "name": "heart",
          "data": "<path pid=\"0\" d=\"M10.8 2.8c-1.1 0-1.8.4-2.6 1.1L8 4l-.2-.1C7 3.1 6.2 2.8 5 2.8c-2.2 0-3.6 1.8-3.6 4 0 2.9 2.9 5.6 6.4 6.9.1.1.3.1.4 0 3.5-1.4 6.4-4.1 6.4-6.9 0-2.3-1.4-4-3.6-4h-.2zM11 4c1.5 0 2.4 1.2 2.4 2.8V7c-.1 2.1-2.4 4.2-5.1 5.4l-.3.2-.3-.2c-2.8-1.2-5.1-3.5-5.1-5.6C2.6 5.2 3.5 4 5 4c1 0 1.6.4 2.6 1.3.2.2.6.2.9 0C9.4 4.3 10 4 11 4z\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "time": {
          "name": "time",
          "data": "<path pid=\"0\" d=\"M8 0c4.4 0 8 3.6 8 8s-3.6 8-8 8-8-3.6-8-8 3.6-8 8-8zm0 1C4.1 1 1 4.1 1 8s3.1 7 7 7 7-3.1 7-7-3.1-7-7-7zm.5 2.4v4.4l1.9 1.8-.7.7-2.2-2V3.4h1z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#181725\" fill-opacity=\".6\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "post": {
          "name": "post",
          "data": "<path pid=\"0\" d=\"M5.5 5l-3 .5h-.1c-.9.2-1.3 1.5-.6 2.2L4 9.9 3.5 13v.1c-.1 1.1 1 1.9 2 1.3L8 13l2.5 1.4.1.1c1 .4 2-.4 1.9-1.5L12 9.9l2.2-2.3.1-.1c.6-.8.2-2-.8-2.1l-3-.5-1.3-2.7c-.5-1.1-1.9-1.1-2.4 0L5.5 5zm2.6-2.3l1.4 3c.1.2.3.4.5.4l3.3.5c.1 0 .1.1 0 .2L11 9.3c-.2.1-.2.3-.2.5l.5 3.3c0 .2-.1.3-.2.2l-2.8-1.5c-.2-.1-.4-.1-.6 0l-2.8 1.6c-.1.1-.2 0-.2-.2l.5-3.3c0-.2 0-.4-.2-.5L2.6 6.8c-.1-.1 0-.2 0-.2L6 6.1c.2 0 .4-.2.5-.4l1.4-3c0-.1.2-.1.2 0z\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "setting": {
          "name": "setting",
          "data": "<path pid=\"0\" d=\"M14.4 9.8l-1-.9c0-.3.1-.6.1-.9s0-.6-.1-.9l1-.9c.2-.1.2-.4.1-.6-.3-.8-.7-1.5-1.2-2.2-.1-.2-.4-.2-.5-.1l-1.3.5c-.5-.4-1-.7-1.6-.9l-.2-1.4c0-.2-.2-.4-.4-.4-.9-.1-1.7-.1-2.5 0-.2 0-.4.2-.4.4l-.3 1.4c-.6.2-1.1.5-1.6.8l-1.3-.4c-.2-.1-.4 0-.5.1-.5.6-1 1.4-1.2 2.2-.1.2 0 .4.1.6l1 .9c0 .3-.1.6-.1.9 0 .3 0 .6.1.9l-1 .9c-.2.1-.2.4-.1.6.3.8.7 1.5 1.2 2.2.1.2.4.2.5.1l1.3-.5c.5.4 1 .7 1.5.9l.2 1.3c0 .2.2.4.4.4.6.2 1 .2 1.4.2s.8 0 1.2-.1c.2 0 .4-.2.4-.4l.2-1.3c.6-.2 1.1-.5 1.6-.9l1.3.5c.2.1.4 0 .5-.1.5-.6 1-1.4 1.2-2.2.3-.4.2-.6 0-.7zm-2.1-2.5c0 .2.1.5.1.7s0 .5-.1.7l-.1.6 1.2 1c-.2.4-.4.8-.7 1.2l-1.4-.5-.5.4c-.4.3-.8.5-1.2.7l-.6.2-.3 1.5c-.4.1-.9.1-1.3 0l-.3-1.5-.6-.2c-.4-.2-.9-.4-1.2-.7l-.6-.4-1.5.5c-.3-.4-.5-.7-.7-1.1l1.2-1v-.7c0-.2-.1-.5-.1-.7 0-.2 0-.5.1-.7l.1-.6-1.2-1c.2-.5.4-.8.7-1.2l1.4.5.5-.4c.4-.3.8-.5 1.3-.7l.6-.2.3-1.5h1.3L9 3.7l.6.2c.4.2.9.4 1.2.7l.5.4 1.5-.5c.3.4.5.7.7 1.2l-1.2 1v.6zM8 5.1c-1.5 0-2.8 1.2-2.8 2.8s1.2 2.8 2.8 2.8 2.8-1.2 2.8-2.8S9.5 5.1 8 5.1zm1.2 4c-.3.3-.7.5-1.2.5s-.9-.2-1.2-.5c-.4-.3-.6-.8-.6-1.3s.2-.9.5-1.2c.4-.3.8-.5 1.3-.5s.9.2 1.2.5c.3.3.5.8.5 1.2.1.5-.1 1-.5 1.3z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#181725\" fill-opacity=\".6\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "link": {
          "name": "link",
          "data": "<path pid=\"0\" _fill=\"none\" d=\"M0 0h16v16H0z\"/><path pid=\"1\" d=\"M12.5 3.1c-1.5-1.5-3.9-1.5-5.3 0L3 7.2v.2l.6.6h.2l4.1-4.1c.5-.5 1.2-.8 1.9-.8a2.732 2.732 0 012.7 2.7c0 .7-.3 1.4-.8 1.9l-4.2 4.2-.7.7c-.6.6-1.7.6-2.3 0-.3-.3-.5-.7-.5-1.1s.2-.8.5-1.1l4.1-4.1c.2-.3.3-.4.5-.4.1 0 .3.1.4.2.1.1.2.2.2.4 0 .1-.1.3-.2.4l-3.4 3.4v.2l.6.5c.1.1.1.1.2 0l3.4-3.4c.3-.3.5-.7.5-1.2s-.2-.9-.5-1.2c-.6-.6-1.7-.6-2.3 0l-.5.5-3.7 3.7c-.5.6-.8 1.2-.8 2a2.732 2.732 0 002.7 2.7c.7 0 1.4-.3 1.9-.8l4.8-4.8c.7-.7 1.1-1.7 1.1-2.7.1-1-.3-2-1-2.7z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#181725\" fill-opacity=\".6\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "breadcrumb": {
          "name": "breadcrumb",
          "data": "<path pid=\"0\" _fill=\"#181725\" d=\"M5.3 16l6.1-16h-1.2L4 16z\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "message": {
          "name": "message",
          "data": "<path pid=\"0\" d=\"M6.3 13.3c.1.8.9 1.5 1.7 1.5.9 0 1.6-.7 1.7-1.5h1.2C10.8 14.8 9.5 16 8 16s-2.8-1.2-2.9-2.7h1.2zM7.4 0h1.2v1.1c2.5.3 4.5 2.4 4.7 5v5.5h1.8v1.2H1v-1.2h1.7V6.3c0-2.7 2-4.9 4.7-5.2V0zM8 2.2C5.8 2.2 4 4 3.9 6.1v5.5h8.2V6.3c0-2.1-1.6-3.8-3.7-4.1H8z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#181725\" fill-opacity=\".6\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "textarea": {
          "name": "textarea",
          "data": "<path pid=\"0\" d=\"M11.3 8.95l.7.7-2.3 2.4-.7-.8 2.3-2.3zm0-4.5l.7.7-6.9 6.8-.7-.7 6.9-6.8z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#181725\" opacity=\".2\"/>",
          "viewBox": "0 0 12 12",
          "width": "12",
          "height": "12"
        },
        "like": {
          "name": "like",
          "data": "<path pid=\"0\" d=\"M6.1 1.8L3.4 5.7c-.1.1-.1.2-.1.4v5.8c0 1.8 1.5 3.2 3.3 3.2h4.3c1.2 0 2.4-.7 2.9-1.8.9-1.7 1.3-3.6 1.3-5.5V7.2c-.1-1-.9-1.8-2-1.8H9l.6-1.6c.4-.9 0-2-.8-2.5-.8-.7-2.1-.4-2.7.5zm2.1.5c.3.2.4.6.3 1l-1 2.5c-.2.5.1.9.6.9h5c.4 0 .7.3.7.6v.5c0 1.7-.4 3.4-1.2 4.9-.3.7-1 1.1-1.8 1.1H6.3c-1-.1-1.8-.9-1.8-1.9V6.3l2.6-3.7c.3-.4.7-.5 1.1-.3zM2.2 6v7.5H.9V6z\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "megui-warn": {
          "name": "megui-warn",
          "data": "<path pid=\"0\" d=\"M8 0c4.4 0 8 3.6 8 8s-3.6 8-8 8-8-3.6-8-8 3.6-8 8-8zm0 1C4.1 1 1 4.1 1 8s3.1 7 7 7 7-3.1 7-7-3.1-7-7-7zm0 9c.4 0 .8.3.8.8s-.4.7-.8.7-.8-.3-.8-.8.4-.7.8-.7zm.4-5.5c.1 0 .1 0 .1.1v4.2c0 .1 0 .1-.1.1h-.8c0 .1-.1.1-.1 0V4.6c0-.1 0-.1.1-.1h.8z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#181725\" fill-opacity=\".6\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "megui-error": {
          "name": "megui-error",
          "data": "<path pid=\"0\" d=\"M8 0c4.4 0 8 3.6 8 8s-3.6 8-8 8-8-3.6-8-8 3.6-8 8-8zm0 1C4.1 1 1 4.1 1 8s3.1 7 7 7 7-3.1 7-7-3.1-7-7-7zm2.6 4.4c.1 0 .1.1.1.1v.1L8.6 8l2 2.4v.1c0 .1-.1.1-.1.1h-1L8 8.8l-1.6 1.9h-1c-.1 0-.1-.1-.1-.1v-.1l2-2.4-2-2.4v-.1c0-.1.1-.1.1-.1h1L8 7.3l1.6-1.9h1z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#181725\" fill-opacity=\".6\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "add_1": {
          "name": "add_1",
          "data": "<path pid=\"0\" d=\"M8 0c4.4 0 8 3.6 8 8s-3.6 8-8 8-8-3.6-8-8 3.6-8 8-8zm0 1C4.1 1 1 4.1 1 8s3.1 7 7 7 7-3.1 7-7-3.1-7-7-7zm.4 2.5c.1 0 .1 0 .1.1v3.9h3.9c.1 0 .1 0 .1.1v.8c0 .1 0 .1-.1.1H8.5v3.9c0 .1 0 .1-.1.1h-.8c-.1 0-.1 0-.1-.1V8.5H3.6c-.1 0-.1 0-.1-.1v-.8c0-.1 0-.1.1-.1h3.9V3.6c0-.1 0-.1.1-.1h.8z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#181725\" fill-opacity=\".6\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "doc": {
          "name": "doc",
          "data": "<g transform=\"translate(3)\"><path pid=\"0\" d=\"M3.8 0c-.5 0-1 .1-1.4.3s-.9.4-1.3.7-.6.7-.8 1.2-.3.9-.3 1.3v28.9c0 .5.1.9.3 1.4s.5.8.8 1.2c.4.3.7.6 1.2.8s.9.2 1.5.2h22.5c.5 0 1-.1 1.4-.3s.8-.4 1.2-.8c.4-.3.6-.7.8-1.2s.3-.9.3-1.4V10.1L19.6 0H3.8z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#bce7ff\"/><defs><filter id=\"svgicon_doc_a\" filterUnits=\"userSpaceOnUse\" x=\"4\" y=\"15\" width=\"22\" height=\"8.6\"><feColorMatrix values=\"1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0\"/></filter></defs><mask maskUnits=\"userSpaceOnUse\" x=\"4\" y=\"15\" width=\"22\" height=\"8.6\" id=\"svgicon_doc_b\"><g filter=\"url(#svgicon_doc_a)\"><path pid=\"1\" d=\"M3.8 0c-.5 0-1 .1-1.4.3s-.9.4-1.3.7-.6.7-.8 1.2-.3.9-.3 1.3v28.9c0 .5.1.9.3 1.4s.5.8.8 1.2c.4.3.7.6 1.2.8s.9.2 1.5.2h22.5c.5 0 1-.1 1.4-.3s.8-.4 1.2-.8c.4-.3.6-.7.8-1.2s.3-.9.3-1.4V10.1L19.6 0H3.8z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#fff\"/></g></mask><path pid=\"2\" d=\"M6.9 23.4c.6 0 1.2-.1 1.7-.2s.9-.4 1.3-.7.6-.7.8-1.3c.2-.5.3-1.2.3-2 0-.9-.1-1.6-.3-2.1-.2-.5-.5-1-.8-1.3-.4-.3-.8-.5-1.3-.6-.5-.1-1.1-.2-1.7-.2H4v8.3h2.9zm-.1-1.5h-1v-5.2h.9c.4 0 .7 0 1 .1.3 0 .6.2.8.4.2.2.3.5.4.8s.1.7.1 1.3c0 .5 0 .9-.1 1.3-.1.3-.2.6-.4.8-.2.2-.4.3-.7.4-.3 0-.7.1-1 .1zm8.7 1.7c.6 0 1.1-.1 1.6-.2s.9-.4 1.2-.7c.3-.3.6-.8.7-1.3.2-.6.2-1.3.2-2.1s-.1-1.5-.2-2.1c-.2-.6-.4-1-.7-1.3-.3-.3-.7-.6-1.2-.7-.5-.1-1-.2-1.6-.2-.6 0-1.1.1-1.6.2s-.9.4-1.2.7c-.3.3-.6.8-.7 1.3-.2.6-.3 1.3-.3 2.1s.1 1.5.3 2.1c.2.6.4 1 .7 1.3.3.3.7.5 1.2.7.4.1 1 .2 1.6.2zm0-1.6c-.4 0-.7 0-.9-.1-.2-.1-.4-.3-.6-.5-.1-.2-.2-.5-.3-.9s-.1-.8-.1-1.3 0-.9.1-1.3.1-.6.3-.9c.1-.2.3-.4.6-.5.2-.1.6-.1.9-.1s.7 0 .9.1.4.3.6.5c.1.2.2.5.3.9.1.4.1.8.1 1.3s0 .9-.1 1.3-.1.6-.3.9c-.1.2-.3.4-.6.5-.3.1-.6.1-.9.1zm8.5 1.6c.4 0 .8 0 1.1-.1.4-.1.7-.1.9-.3v-1.6c-.3.1-.6.2-1 .2s-.6.1-1 .1-.7 0-1-.1c-.3-.1-.5-.2-.7-.4-.2-.2-.3-.5-.4-.8.1-.3.1-.8.1-1.3s0-.9.1-1.3c.1-.3.2-.6.4-.8.2-.2.4-.4.7-.5.3-.1.6-.1 1-.1s.7 0 1 .1c.3.1.6.1.8.2v-1.6c-.6-.2-1.2-.3-2-.3-.6 0-1.2.1-1.7.2s-.9.4-1.3.7c-.4.3-.6.8-.8 1.3-.2.5-.3 1.2-.3 2 0 .9.1 1.6.3 2.1.2.6.5 1 .8 1.3.4.3.8.5 1.3.7.5.2 1.1.3 1.7.3z\" mask=\"url(#svgicon_doc_b)\" _fill=\"#00a5ff\"/><path pid=\"3\" d=\"M22 10c-1.1 0-2-.9-2-2V0l10 10h-8z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#00a5ff\"/></g>",
          "viewBox": "0 0 36 36",
          "width": "36",
          "height": "36"
        },
        "pdf": {
          "name": "pdf",
          "data": "<path pid=\"0\" d=\"M6.8 0c-.5 0-1 .1-1.4.3s-.9.4-1.3.7-.6.7-.8 1.2-.3.9-.3 1.3v28.9c0 .5.1.9.3 1.4s.5.8.8 1.2c.4.3.7.6 1.2.8s.9.2 1.5.2h22.5c.5 0 1-.1 1.4-.3s.8-.4 1.2-.8c.4-.3.6-.7.8-1.2s.3-.9.3-1.4V10.1L22.6 0H6.8z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#e2dbff\"/><path pid=\"1\" d=\"M25 10c-1.1 0-2-.9-2-2V0l10 10h-8z\" _fill=\"#9178fc\"/><path pid=\"2\" d=\"M8.8 23.3v-2.6h1c.6 0 1.1-.1 1.5-.1.4-.1.8-.3 1-.5s.5-.5.6-.9c.1-.4.2-.8.2-1.4 0-.5-.1-.9-.2-1.3s-.3-.6-.5-.9c-.3-.2-.6-.4-1-.5-.4 0-.9-.1-1.6-.1H7v8.3h1.8zm.8-4h-.8v-2.9h.8c.3 0 .6 0 .8.1.2 0 .4.1.5.2.1.1.2.3.3.4.1.2.1.4.1.7 0 .3 0 .5-.1.7-.1.2-.1.3-.3.4s-.3.2-.5.2c-.2.2-.5.2-.8.2zm7.9 4c.6 0 1.2-.1 1.7-.2s.9-.4 1.3-.7c.4-.3.6-.7.8-1.3s.3-1.2.3-2c0-.9-.1-1.6-.3-2.1s-.5-1-.8-1.3c-.4-.3-.8-.5-1.3-.6-.5-.1-1.1-.2-1.7-.2h-2.9v8.3h2.9zm-.1-1.5h-.9v-5.2h.9c.4 0 .7 0 1 .1.3.1.5.2.7.4.2.2.3.5.4.8.1.3.1.8.1 1.3s0 .9-.1 1.3c-.1.3-.2.6-.4.8-.2.2-.4.3-.7.4-.3 0-.6.1-1 .1zm7.6 1.5v-3.2h3v-1.6h-3v-1.9h3.3V15h-5.1v8.3H25z\" _fill=\"#6e51ea\"/>",
          "viewBox": "0 0 36 36",
          "width": "36",
          "height": "36"
        },
        "AI": {
          "name": "AI",
          "data": "<g transform=\"translate(3)\"><path pid=\"0\" d=\"M3.8 0c-.5 0-1 .1-1.4.3s-.9.4-1.3.7-.6.7-.8 1.2-.3.9-.3 1.3v28.7c0 .4.1.9.3 1.3s.5.8.8 1.2.7.6 1.2.8c.4.2.9.3 1.4.3h22.5c.5 0 1-.1 1.4-.3.4-.2.8-.4 1.2-.8.4-.3.6-.7.8-1.2s.3-.9.3-1.3V10L19.6 0H3.8z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#ffe4cb\"/><defs><filter id=\"svgicon_AI_a\" filterUnits=\"userSpaceOnUse\" x=\"8\" y=\"15\" width=\"13.3\" height=\"9.7\"><feColorMatrix values=\"1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0\"/></filter></defs><mask maskUnits=\"userSpaceOnUse\" x=\"8\" y=\"15\" width=\"13.3\" height=\"9.7\" id=\"svgicon_AI_b\"><g filter=\"url(#svgicon_AI_a)\"><path pid=\"1\" d=\"M3.8 0c-.5 0-1 .1-1.4.3s-.9.4-1.3.7-.6.7-.8 1.2-.3.9-.3 1.3v28.7c0 .4.1.9.3 1.3s.5.8.8 1.2.7.6 1.2.8c.4.2.9.3 1.4.3h22.5c.5 0 1-.1 1.4-.3.4-.2.8-.4 1.2-.8.4-.3.6-.7.8-1.2s.3-.9.3-1.3V10L19.6 0H3.8z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#fff\"/></g></mask><path pid=\"2\" d=\"M10.2 24.7l.8-2.4h4l.8 2.4h2.3L14.5 15h-2.9L8 24.7h2.2zm4.2-4.2h-2.7l1.3-3.7h.2l1.2 3.7zm6.9 4.2V15h-2.1v9.7h2.1z\" mask=\"url(#svgicon_AI_b)\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#ff8e27\"/><path pid=\"3\" d=\"M22 10c-1.1 0-2-.9-2-2V0l10 10h-8z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#fea453\"/></g>",
          "viewBox": "0 0 36 36",
          "width": "36",
          "height": "36"
        },
        "ppt": {
          "name": "ppt",
          "data": "<g transform=\"translate(3)\"><path pid=\"0\" d=\"M3.8 0c-.5 0-1 .1-1.4.3s-.9.4-1.3.7-.6.7-.8 1.2-.3.9-.3 1.3v28.9c0 .5.1.9.3 1.4s.5.8.8 1.2c.4.3.7.6 1.2.8s.9.2 1.5.2h22.5c.5 0 1-.1 1.4-.3s.8-.4 1.2-.8c.4-.3.6-.7.8-1.2s.3-.9.3-1.4V10.1L19.6 0H3.8z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#ffe5c5\"/><defs><filter id=\"svgicon_ppt_a\" filterUnits=\"userSpaceOnUse\" x=\"5\" y=\"15\" width=\"20.5\" height=\"8.3\"><feColorMatrix values=\"1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0\"/></filter></defs><mask maskUnits=\"userSpaceOnUse\" x=\"5\" y=\"15\" width=\"20.5\" height=\"8.3\" id=\"svgicon_ppt_b\"><g filter=\"url(#svgicon_ppt_a)\"><path pid=\"1\" d=\"M3.8 0c-.5 0-1 .1-1.4.3s-.9.4-1.3.7-.6.7-.8 1.2-.3.9-.3 1.3v28.9c0 .5.1.9.3 1.4s.5.8.8 1.2c.4.3.7.6 1.2.8s.9.2 1.5.2h22.5c.5 0 1-.1 1.4-.3s.8-.4 1.2-.8c.4-.3.6-.7.8-1.2s.3-.9.3-1.4V10.1L19.6 0H3.8z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#fff\"/></g></mask><path pid=\"2\" d=\"M6.8 23.3v-2.6h1c.6 0 1.1-.1 1.5-.1.4-.1.8-.3 1-.5s.5-.5.6-.9c.1-.4.2-.8.2-1.4 0-.5-.1-.9-.2-1.3s-.3-.6-.5-.9c-.3-.2-.6-.4-1-.5-.4 0-.9-.1-1.6-.1H5v8.3h1.8zm.8-4h-.8v-2.9h.8c.3 0 .6 0 .8.1.2 0 .4.1.5.2.1.2.2.3.3.5.1.2.1.4.1.7 0 .3 0 .5-.1.7-.1.1-.2.3-.3.4s-.3.2-.5.2c-.2.1-.5.1-.8.1zm6.8 4v-2.6h1c.6 0 1.1-.1 1.5-.1.4-.1.8-.3 1-.5s.5-.5.6-.9c.1-.4.2-.8.2-1.4 0-.5-.1-.9-.2-1.3s-.3-.6-.5-.9c-.3-.2-.6-.4-1-.5-.4-.1-.9-.2-1.6-.2h-2.8v8.3h1.8zm.8-4h-.8v-2.9h.8c.3 0 .6 0 .8.1.2 0 .4.1.5.2.1.1.2.3.3.4s.1.4.1.7c0 .3 0 .5-.1.7s-.1.3-.3.4-.3.2-.5.2c-.2.2-.5.2-.8.2zm8.1 4v-6.7h2.2V15h-6.2v1.6h2.2v6.7h1.8z\" mask=\"url(#svgicon_ppt_b)\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#fe9b24\"/><path pid=\"3\" d=\"M22 10c-1.1 0-2-.9-2-2V0l10 10h-8z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#ffa63b\"/></g>",
          "viewBox": "0 0 36 36",
          "width": "36",
          "height": "36"
        },
        "folder": {
          "name": "folder",
          "data": "<g fill-rule=\"evenodd\" clip-rule=\"evenodd\"><path pid=\"0\" d=\"M6 5.8h6.6c.3 0 .6.1.7.3l1.8 2h13.1l4 3.1L16 12 2 14.1V9.8c0-2.2 1.8-4 4-4z\" _fill=\"#70c5ff\"/><path pid=\"1\" d=\"M6 10h24c2.2 0 4 1.8 4 4v14c0 2.2-1.8 4-4 4H6c-2.2 0-4-1.8-4-4V14c0-2.2 1.8-4 4-4z\" _fill=\"#1198f6\"/></g>",
          "viewBox": "0 0 36 36",
          "width": "36",
          "height": "36"
        },
        "sketch": {
          "name": "sketch",
          "data": "<path pid=\"0\" d=\"M6.8 0c-.5 0-1 .1-1.4.3s-.9.4-1.3.7-.6.7-.8 1.2-.3.9-.3 1.3v28.7c0 .4.1.9.3 1.3s.5.8.8 1.2.7.6 1.2.8c.4.2.9.3 1.4.3h22.5c.5 0 1-.1 1.4-.3.4-.2.8-.4 1.2-.8.4-.3.6-.7.8-1.2s.3-.9.3-1.3V10L22.6 0H6.8z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#ffeac1\"/><path pid=\"1\" d=\"M20.8 17.2L18 25.5l-2.7-8.3h5.5zm.5 0H25l-6.2 7.7 2.5-7.7zm-6.6 0l2.5 7.7-6.2-7.7h3.7zM18 13l2.6 3.6h-5.2L18 13zm-.7 0l-2.6 3.6h-3.6L13 14l4.3-1zm1.4 0l4.3 1 1.9 2.6h-3.7L18.7 13zM25 10c-1.1 0-2-.9-2-2V0l10 10h-8z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#fb3\"/>",
          "viewBox": "0 0 36 36",
          "width": "36",
          "height": "36"
        },
        "PS": {
          "name": "PS",
          "data": "<path pid=\"0\" d=\"M6.8 0c-.5 0-1 .1-1.4.3s-.9.4-1.3.7-.6.7-.8 1.2-.3.9-.3 1.3v28.9c0 .5.1.9.3 1.4s.5.8.8 1.2c.4.3.7.6 1.2.8s.9.2 1.5.2h22.5c.5 0 1-.1 1.4-.3s.8-.4 1.2-.8c.4-.3.6-.7.8-1.2s.3-.9.3-1.4V10.1L22.6 0H6.8z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#cfe5ff\"/><path pid=\"1\" d=\"M25 10c-1.1 0-2-.9-2-2V0l10 10h-8z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#4192f4\"/><path pid=\"2\" d=\"M12.2 23.9v-3h1.3c.7 0 1.3-.1 1.9-.2.5-.1.9-.3 1.3-.6.3-.3.6-.6.7-1.1s.2-1 .2-1.6c0-.6-.1-1.1-.2-1.5-.1-.4-.4-.8-.7-1s-.7-.5-1.2-.6c-.5-.1-1.2-.2-1.9-.2H10v9.7h2.2zm1-4.7h-1v-3.3h1c.4 0 .7 0 1 .1.3.1.5.1.6.3.2.1.3.3.3.5s.1.5.1.8c0 .3 0 .6-.1.8-.1.2-.2.4-.3.5l-.6.3c-.3-.1-.6 0-1 0zM22 24c1.4 0 2.4-.2 3-.7.6-.5.9-1.2.9-2.2 0-.5 0-.8-.1-1.2-.1-.3-.2-.6-.5-.8-.2-.2-.5-.4-.9-.6-.4-.2-.9-.3-1.5-.5-.4-.1-.7-.2-.9-.2-.2-.1-.4-.2-.5-.2-.1-.1-.2-.2-.2-.3s-.1-.2-.1-.4c0-.4.1-.7.4-.8s.7-.2 1.3-.2h.7c.2 0 .5 0 .7.1.2 0 .5.1.7.1s.4.1.5.1v-1.8c-.3-.1-.6-.2-1.1-.2-.4-.1-1-.1-1.5-.1-1.2 0-2.1.2-2.8.7-.7.4-1 1.2-1 2.2 0 .4 0 .8.1 1.1.1.3.2.6.5.8.2.2.5.4.9.5.4.1.8.3 1.4.4.4.1.7.2 1 .3l.6.3c.1.1.2.2.3.4 0 .1.1.3.1.5s0 .4-.1.5-.2.3-.3.4c-.1.1-.3.2-.6.2s-.5.1-.9.1h-.8c-.3 0-.5-.1-.8-.1-.3 0-.5-.1-.7-.1-.2 0-.4-.1-.6-.2V24c.3.1.7.2 1.3.2.4-.2.9-.2 1.5-.2z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#1067d1\"/>",
          "viewBox": "0 0 36 36",
          "width": "36",
          "height": "36"
        },
        "megui-fill-checked": {
          "name": "megui-fill-checked",
          "data": "<path pid=\"0\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#1067d1\" d=\"M6.3 10.1L2.9 6.5 1 8.4l3.5 3.7L6.3 14l1.9-1.9L15 4.9 13.1 3z\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "fill-data": {
          "name": "fill-data",
          "data": "<path pid=\"0\" d=\"M2.9 6.7c0-.3.2-.5.5-.5h1.8c.3 0 .5.2.5.5v5.5h.9V2.5c0-.3.2-.5.5-.5h1.8c.3 0 .5.2.5.5v9.7h.9v-7c0-.3.2-.5.5-.5h1.8c.3 0 .5.2.5.5v7h.9v1H2v-1h.9V6.7z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#181725\" fill-opacity=\".6\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "fill-form": {
          "name": "fill-form",
          "data": "<path pid=\"0\" d=\"M11.9 2.6c.6 0 1 .4 1 1v7.7l-2.7 2.3H3.9c-.6 0-1-.4-1-1v-9c0-.6.4-1 1-1h8zM8.8 9.9H4.6v1h4.2v-1zm2.5-2.7H4.6v1h6.7v-1zm0-2.8H4.6v1h6.7v-1z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#181725\" fill-opacity=\".6\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "megui-loading2": {
          "name": "megui-loading2",
          "data": "<g transform=\"rotate(43 9.845 30.155)\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#fff\"><circle pid=\"0\" cx=\"7.5\" cy=\"7\" r=\"6.8\"/><circle pid=\"1\" cx=\"6.9\" cy=\"23.9\" r=\"6.8\" fill-opacity=\".2\"/><circle pid=\"2\" cx=\"24.5\" cy=\"7.6\" r=\"6.8\" opacity=\".8\"/><circle pid=\"3\" cx=\"23.9\" cy=\"24.5\" r=\"6.8\" fill-opacity=\".4\"/></g>",
          "viewBox": "0 0 48 48",
          "width": "48",
          "height": "48"
        },
        "fill-sort": {
          "name": "fill-sort",
          "data": "<path pid=\"0\" d=\"M12.7 10c.3 0 .4.3.3.5l-4.7 5.4c-.1.2-.4.2-.5 0l-4.7-5.4c-.2-.2 0-.5.3-.5h9.3zM7.7.1c.2-.1.4-.1.6 0L13 5.5c.2.2 0 .5-.3.5H3.3c-.2 0-.4-.3-.2-.5L7.7.1z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#181725\" fill-opacity=\".6\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "fill-layout-check": {
          "name": "fill-layout-check",
          "data": "<g fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#1067d1\" opacity=\".8\"><path pid=\"0\" d=\"M3 2h4c.6 0 1 .4 1 1v4c0 .6-.4 1-1 1H3c-.6 0-1-.4-1-1V3c0-.6.4-1 1-1zM10 8h3c.6 0 1 .4 1 1v4c0 .6-.4 1-1 1h-3c-.6 0-1-.4-1-1V9c0-.6.4-1 1-1z\"/><path pid=\"1\" d=\"M10 2h3c.6 0 1 .4 1 1v3c0 .6-.4 1-1 1h-3c-.6 0-1-.4-1-1V3c0-.6.4-1 1-1zM3 9h4c.6 0 1 .4 1 1v3c0 .6-.4 1-1 1H3c-.6 0-1-.4-1-1v-3c0-.6.4-1 1-1z\" fill-opacity=\".4\"/></g>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "fill-reset": {
          "name": "fill-reset",
          "data": "<path pid=\"0\" d=\"M11.3 10.2v3.3H4.7v-3.3h6.6zm.6-7.2c.6 0 1 .4 1 1v.3l-1.6 4.9c-.1.2-.3.3-.5.3H5.2c-.2.1-.4-.1-.5-.3L3.2 4.3c-.2-.5.1-1.1.6-1.3h8.1z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#181725\" fill-opacity=\".6\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "fill-scale": {
          "name": "fill-scale",
          "data": "<path pid=\"0\" d=\"M15 13v2H1v-2h14zm0-4v2H8V9h7zM6 5v6L1 8l5-3zm9 0v2H8V5h7zm0-4v2H1V1h14z\" _fill=\"#181725\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "fill-team": {
          "name": "fill-team",
          "data": "<g fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#333\"><path pid=\"0\" d=\"M5.5 4.7c0 1.4 1.1 2.5 2.5 2.5s2.5-1.1 2.5-2.5S9.4 2.3 8 2.3 5.5 3.4 5.5 4.7zM4.6 6.8c-.8-.4-1.2-1.2-1.2-2.1 0-.8.4-1.6 1.1-2 .2-.2.5-.1.7.2.1.2.1.5-.2.7-.3.3-.5.7-.5 1.1 0 .5.2.9.7 1.2.3.2.3.5.2.7-.2.2-.4.3-.6.3-.1 0-.2 0-.2-.1zM10.8 6.6c-.1-.2-.1-.6.2-.7.4-.3.6-.7.6-1.1 0-.4-.2-.9-.6-1.1-.3-.3-.3-.6-.2-.8.2-.3.5-.4.8-.2.7.5 1.1 1.2 1.1 2s-.4 1.6-1.1 2c-.1.1-.2.1-.3.1-.2 0-.4 0-.5-.2zM10.1 8.5c-.5-.2-1-.2-2.1-.2s-1.6 0-2.1.2c-.7.3-1.2.8-1.5 1.5-.2.5-.2 1-.2 2.1v.5c0 .3.2.5.5.5h6.5c.3 0 .5-.2.5-.5v-.5c0-1.1 0-1.6-.2-2.1-.2-.7-.7-1.2-1.4-1.5zM12.9 12.6v-.3c0-1.1 0-1.7-.2-2.1-.1-.2-.4-.5-.7-.7-.3-.1-.4-.4-.2-.7.1-.3.5-.4.7-.2.5.3.9.7 1.2 1.2.3.6.3 1.2.3 2.5v.3c0 .3-.2.5-.5.5s-.6-.2-.6-.5zM2 12.6v-.3c0-1.3 0-2 .3-2.5s.7-1 1.2-1.2c.3-.1.6 0 .7.2.1.3 0 .6-.2.7-.3.2-.6.5-.7.8-.2.4-.2.9-.2 2.1v.3c0 .3-.2.5-.5.5s-.6-.3-.6-.6z\"/></g>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "fill-layout-white": {
          "name": "fill-layout-white",
          "data": "<path pid=\"0\" d=\"M3 2h4c.6 0 1 .4 1 1v4c0 .6-.4 1-1 1H3c-.6 0-1-.4-1-1V3c0-.6.4-1 1-1zM10 8h3c.6 0 1 .4 1 1v4c0 .6-.4 1-1 1h-3c-.6 0-1-.4-1-1V9c0-.6.4-1 1-1z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#fff\"/><path pid=\"1\" d=\"M10 2h3c.6 0 1 .4 1 1v3c0 .6-.4 1-1 1h-3c-.6 0-1-.4-1-1V3c0-.6.4-1 1-1zM3 9h4c.6 0 1 .4 1 1v3c0 .6-.4 1-1 1H3c-.6 0-1-.4-1-1v-3c0-.6.4-1 1-1z\" opacity=\".6\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#fff\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "fill-settings": {
          "name": "fill-settings",
          "data": "<path pid=\"0\" d=\"M8.8 1.7c.3 0 .5.2.5.5v1h.1c.3.1.7.2 1 .4l.1.1.7-.7c.2-.2.4-.2.6-.1l.1.1L13 4.1c.2.2.2.5 0 .7l-.7.7.1.1c.2.3.3.6.4 1v.1h1c.2 0 .4.2.5.4V8.8c0 .3-.2.5-.5.5h-1v.1c-.1.3-.2.7-.4 1l-.1.1.7.7c.2.2.2.4.1.6l-.1.1-1.1 1.1c-.2.2-.5.2-.7 0l-.7-.7-.1.1c-.3.2-.6.3-1 .4h-.1v1c0 .2-.2.4-.4.5H7.2c-.3 0-.5-.2-.5-.5v-1h-.1c-.3-.1-.7-.2-1-.4l-.1-.1-.7.7c-.2.2-.4.2-.6.1l-.1-.1L3 11.9c-.2-.2-.2-.5 0-.7l.7-.7-.1-.1c-.2-.3-.3-.6-.4-1v-.1h-1c-.2 0-.4-.2-.5-.4V7.2c0-.3.2-.5.5-.5h1v-.1c.1-.3.2-.7.4-1l.1-.1-.7-.7c-.2-.2-.2-.5-.1-.6l.1-.1L4.1 3c.2-.2.5-.2.7 0l.7.7.1-.1c.3-.2.6-.3 1-.4h.1v-1c0-.2.2-.4.4-.5H8.8zM8 5.5C6.6 5.5 5.5 6.6 5.5 8s1.1 2.5 2.5 2.5 2.5-1.1 2.5-2.5S9.4 5.5 8 5.5z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#181725\" fill-opacity=\".6\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "fill-slash": {
          "name": "fill-slash",
          "data": "<path pid=\"0\" d=\"M17.2 2v.1L8.2 22H6v-.1L15 2h2.2z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#181725\"/>",
          "viewBox": "0 0 24 24",
          "width": "24",
          "height": "24"
        },
        "mul-check": {
          "name": "mul-check",
          "data": "<path pid=\"0\" _fill=\"none\" d=\"M0 0h16v16H0z\"/><path pid=\"1\" d=\"M14 0c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H2c-1.1 0-2-.9-2-2V2C0 .9.9 0 2 0h12zm-2.4 5h-.9c-.2 0-.4.1-.5.3L7 9.6l-1.4-2c-.1-.1-.3-.2-.5-.2h-.9c-.2 0-.2.1-.2.2l2.5 3.5c.3.4.8.4 1 0l4.2-5.8c.1-.2.1-.3-.1-.3z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#1067d1\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "un-check": {
          "name": "un-check",
          "data": "<path pid=\"0\" d=\"M14 0c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H2c-1.1 0-2-.9-2-2V2C0 .9.9 0 2 0h12zm0 1H2c-.5 0-.9.4-1 .9V14c0 .5.4.9.9 1H14c.5 0 .9-.4 1-.9V2c0-.5-.4-.9-.9-1H14z\" fill-opacity=\".2\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "check-disabled": {
          "name": "check-disabled",
          "data": "<path pid=\"0\" d=\"M14 0c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H2c-1.1 0-2-.9-2-2V2C0 .9.9 0 2 0h12zm0 1H2c-.5 0-.9.4-1 .9V14c0 .5.4.9.9 1H14c.5 0 .9-.4 1-.9V2c0-.5-.4-.9-.9-1H14z\" fill-opacity=\".15\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "un-expand": {
          "name": "un-expand",
          "data": "<path pid=\"0\" d=\"M14 0c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H2c-1.1 0-2-.9-2-2V2C0 .9.9 0 2 0h12zm0 1H2c-.5 0-.9.4-1 .9V14c0 .5.4.9.9 1H14c.5 0 .9-.4 1-.9V2c0-.5-.4-.9-.9-1H14z\" fill-opacity=\".2\"/><path pid=\"1\" d=\"M8.5 3.5v4h4.2v1H8.5v4h-1v-4H3.2v-1h4.2v-4h1.1z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#181725\" fill-opacity=\".6\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "expand": {
          "name": "expand",
          "data": "<path pid=\"0\" _fill=\"none\" d=\"M0 0h16v16H0z\"/><path pid=\"1\" d=\"M14 0c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H2c-1.1 0-2-.9-2-2V2C0 .9.9 0 2 0h12zm0 1H2c-.5 0-.9.4-1 .9V14c0 .5.4.9.9 1H14c.5 0 .9-.4 1-.9V2c0-.5-.4-.9-.9-1H14z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#1067d1\"/><g><path pid=\"2\" _fill=\"#1067d1\" d=\"M12.8 7.5v1H3.2v-1z\"/></g>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "half-check": {
          "name": "half-check",
          "data": "<path pid=\"0\" _fill=\"none\" d=\"M0 0h16v16H0z\"/><path pid=\"1\" d=\"M14 0c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H2c-1.1 0-2-.9-2-2V2C0 .9.9 0 2 0h12zm0 1H2c-.5 0-.9.4-1 .9V14c0 .5.4.9.9 1H14c.5 0 .9-.4 1-.9V2c0-.5-.4-.9-.9-1H14z\" fill-opacity=\".2\"/><path pid=\"2\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#1067d1\" d=\"M4 4h8v8H4z\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "process": {
          "name": "process",
          "data": "<circle pid=\"0\" cx=\"12\" cy=\"12\" r=\"12\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#1067d1\"/><text transform=\"translate(9.193 16.396)\" font-size=\"14\" font-family=\"PingFangSC-Regular-GBpc-EUC-H\" _fill=\"#fff\">1</text>",
          "viewBox": "0 0 24 24",
          "width": "24",
          "height": "24"
        },
        "finish": {
          "name": "finish",
          "data": "<path pid=\"0\" d=\"M12 0c6.6 0 12 5.4 12 12s-5.4 12-12 12S0 18.6 0 12 5.4 0 12 0zm0 1C5.9 1 1 5.9 1 12s4.9 11 11 11 11-4.9 11-11S18.1 1 12 1zm5.1 7c.2.2.2.6 0 .8l-6.7 7.5c-.1.1-.2.1-.3.2-.2 0-.4 0-.5-.1l-.1-.1-2.6-2.9c-.2-.2-.2-.6 0-.8.2-.2.5-.2.7 0l.1.1L10 15l6.3-7c.2-.2.5-.2.8 0z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#1067d1\"/>",
          "viewBox": "0 0 24 24",
          "width": "24",
          "height": "24"
        },
        "wait": {
          "name": "wait",
          "data": "<path pid=\"0\" d=\"M12 0c6.6 0 12 5.4 12 12s-5.4 12-12 12S0 18.6 0 12 5.4 0 12 0zm0 1C5.9 1 1 5.9 1 12s4.9 11 11 11 11-4.9 11-11S18.1 1 12 1z\" fill-opacity=\".15\"/><text transform=\"translate(9 16)\" font-size=\"14\" font-family=\"PingFangSC-Regular-GBpc-EUC-H\">1</text>",
          "viewBox": "0 0 24 24",
          "width": "24",
          "height": "24"
        },
        "megui-layout-uncheck": {
          "name": "megui-layout-uncheck",
          "data": "<path pid=\"0\" _fill=\"none\" d=\"M2 2h12v12H2z\"/><g fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#181725\"><path pid=\"1\" d=\"M3 2h4c.6 0 1 .4 1 1v4c0 .6-.4 1-1 1H3c-.6 0-1-.4-1-1V3c0-.6.4-1 1-1z\" fill-opacity=\".6\"/><path pid=\"2\" d=\"M3 9h4c.6 0 1 .4 1 1v3c0 .6-.4 1-1 1H3c-.6 0-1-.4-1-1v-3c0-.6.4-1 1-1z\"/><path pid=\"3\" d=\"M10 11h3c.6 0 1 .4 1 1v1c0 .6-.4 1-1 1h-3c-.6 0-1-.4-1-1v-1c0-.6.4-1 1-1z\" fill-opacity=\".6\"/><path pid=\"4\" d=\"M10 2h3c.6 0 1 .4 1 1v6c0 .6-.4 1-1 1h-3c-.6 0-1-.4-1-1V3c0-.6.4-1 1-1z\"/></g>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "megui-check": {
          "name": "megui-check",
          "data": "<path pid=\"0\" d=\"M14.7 3l-7.6 9.7c-.2.2-.5.3-.7.1l-.1-.1L2 7.3h1.6l3.1 3.9L13.1 3h1.6z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#181725\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "megui-fill-down": {
          "name": "megui-fill-down",
          "data": "<path pid=\"0\" d=\"M12.7 5.5l-4.5 5.3c-.1.2-.4.2-.5 0L3.1 5.5c-.2-.2 0-.5.2-.5h9.1c.3 0 .4.3.3.5z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "megui-menu-media": {
          "name": "megui-menu-media",
          "data": "<g fill-rule=\"evenodd\" clip-rule=\"evenodd\"><path pid=\"0\" _fill=\"#d8d8d8\" d=\"M0 0h16v2.7H0zM0 13.3h16V16H0z\"/><path pid=\"1\" d=\"M15 4c.6 0 1 .4 1 1v6c0 .6-.4 1-1 1H1c-.6 0-1-.4-1-1V5c0-.6.4-1 1-1h14zM6.8 5.4c-.2-.1-.4-.1-.5 0s-.3.2-.3.4v4.4c0 .2.1.3.3.4.1 0 .2.1.3.1.1 0 .2 0 .3-.1l2.9-2.2c.1-.1.2-.2.2-.4s-.1-.3-.3-.4L6.8 5.4z\" _fill=\"#8c8c93\"/></g>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "megui-menu-console": {
          "name": "megui-menu-console",
          "data": "<g fill-rule=\"evenodd\" clip-rule=\"evenodd\"><path pid=\"0\" d=\"M1 0h5c.6 0 1 .4 1 1v6c0 .6-.4 1-1 1H1c-.6 0-1-.4-1-1V1c0-.6.4-1 1-1z\" _fill=\"#8c8c93\"/><path pid=\"1\" _fill=\"#d8d8d8\" d=\"M9 0h7v5H9zM0 10h7v5H0zM10 7h5c.6 0 1 .4 1 1v6c0 .6-.4 1-1 1h-5c-.6 0-1-.4-1-1V8c0-.6.4-1 1-1z\"/></g>",
          "viewBox": "0 0 16 15",
          "width": "16",
          "height": "15"
        },
        "megui-menu-feedback": {
          "name": "megui-menu-feedback",
          "data": "<g fill-rule=\"evenodd\" clip-rule=\"evenodd\"><path pid=\"0\" d=\"M15.2 3.2h-1.6v8.5H3.2v1.6c0 .4.4.8.8.8h8.8L16 16V4c0-.4-.4-.8-.8-.8z\" _fill=\"#d8d8d8\"/><path pid=\"1\" d=\"M12.7 9.8v-9c0-.4-.4-.8-.8-.8H.8C.4 0 0 .4 0 .8v12.6l3.2-2.7h8.7c.4-.1.8-.4.8-.9z\" _fill=\"#8c8c93\"/></g>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "megui-menu-layout": {
          "name": "megui-menu-layout",
          "data": "<g fill-rule=\"evenodd\" clip-rule=\"evenodd\"><path pid=\"0\" d=\"M1.8 1.3c.6 0 1 .4 1 1v11.3c0 .6-.4 1-1 1H1c-.6 0-1-.4-1-1V2.3c0-.6.4-1 1-1h.8zm13.2 0c.6 0 1 .4 1 1v11.3c0 .6-.4 1-1 1h-.8c-.6 0-1-.4-1-1V2.3c0-.6.4-1 1-1h.8z\" _fill=\"#8c8c93\"/><path pid=\"1\" d=\"M4.8 16h6.5c.6 0 1-.4 1-1V1c0-.6-.4-1-1-1H4.8c-.6 0-1 .4-1 1v14c0 .6.4 1 1 1z\" _fill=\"#d8d8d8\"/></g>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "megui-menu-charts": {
          "name": "megui-menu-charts",
          "data": "<g fill-rule=\"evenodd\" clip-rule=\"evenodd\"><path pid=\"0\" d=\"M7.3.5v8H15.6c0 4.2-3.6 7.5-7.8 7.5C3.4 16 0 12.7 0 8.4 0 4.2 3.1.5 7.3.5z\" _fill=\"#8c8c93\"/><path pid=\"1\" d=\"M8.2 0C12.5 0 16 3.3 16 7.5H8.3h-.1V0z\" _fill=\"#d8d8d8\"/></g>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "megui-menu-display": {
          "name": "megui-menu-display",
          "data": "<g fill-rule=\"evenodd\" clip-rule=\"evenodd\"><path pid=\"0\" d=\"M15 5.3c.6 0 1 .4 1 1V15c0 .6-.4 1-1 1H1c-.6 0-1-.4-1-1V6.3c0-.6.4-1 1-1h14zm-2 6.1H2.3v1.9H13v-1.9zM7.6 8H2.3v1.9h5.3V8z\" _fill=\"#d8d8d8\"/><path pid=\"1\" d=\"M1 0h14c.6 0 1 .4 1 1v2c0 .6-.4 1-1 1H1c-.6 0-1-.4-1-1V1c0-.6.4-1 1-1z\" _fill=\"#8c8c93\"/></g>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "megui-menu-base": {
          "name": "megui-menu-base",
          "data": "<g fill-rule=\"evenodd\" clip-rule=\"evenodd\"><path pid=\"0\" d=\"M6.5 0C7.8 0 9 .4 10 1L6.1 7.7l-2.4 4.2C1.6 10.9.2 8.7.2 6.3.2 2.8 3.1 0 6.5 0z\" _fill=\"#d8d8d8\"/><path pid=\"1\" d=\"M6.7 10.2l2.5-4.4.3-.3c.5-.3 1.1-.1 1.3.3l2.5 4.4 2.6 4.3c.1.2.1.3.1.5 0 .5-.4.9-.9.9h-10c-.2 0-.3 0-.5-.1-.4-.3-.6-.9-.3-1.3l2.4-4.3z\" _fill=\"#8c8c93\"/></g>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "megui-menu-input": {
          "name": "megui-menu-input",
          "data": "<g fill-rule=\"evenodd\" clip-rule=\"evenodd\"><path pid=\"0\" d=\"M14.9 4.4S14.1.2 10 0c0 0 2.3 2.7 1.5 4.4H9.9l3 4.8 3-4.8h-1z\" _fill=\"#8c8c93\"/><path pid=\"1\" d=\"M16 10.2v2.3H0V0h8.4v9.1c0 .6.5 1 1 1H16v.1z\" _fill=\"#d8d8d8\"/><path pid=\"2\" _fill=\"#8c8c93\" d=\"M16 16H0v-2.6h16z\"/></g>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "megui-menu-nav": {
          "name": "megui-menu-nav",
          "data": "<g fill-rule=\"evenodd\" clip-rule=\"evenodd\"><path pid=\"0\" d=\"M3.7 4v12H0V4h3.7zM16 0v2.7H0V0h16z\" _fill=\"#8c8c93\"/><path pid=\"1\" d=\"M5.9 4H15c.6 0 1 .4 1 1v10c0 .6-.4 1-1 1H5.9c-.6 0-1-.4-1-1V5c0-.6.5-1 1-1z\" _fill=\"#d8d8d8\"/></g>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "megui-menu-media-active": {
          "name": "megui-menu-media-active",
          "data": "<g fill-rule=\"evenodd\" clip-rule=\"evenodd\"><path pid=\"0\" _fill=\"#70a4e3\" d=\"M0 0h16v2.7H0zM0 13.3h16V16H0z\"/><path pid=\"1\" d=\"M15 4c.6 0 1 .4 1 1v6c0 .6-.4 1-1 1H1c-.6 0-1-.4-1-1V5c0-.6.4-1 1-1h14zM6.8 5.4c-.2-.1-.4-.1-.5 0s-.3.2-.3.4v4.4c0 .2.1.3.3.4.1 0 .2.1.3.1.1 0 .2 0 .3-.1l2.9-2.2c.1-.1.2-.2.2-.4s-.1-.3-.3-.4L6.8 5.4z\" _fill=\"#1067d1\"/></g>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "megui-menu-base-active": {
          "name": "megui-menu-base-active",
          "data": "<g fill-rule=\"evenodd\" clip-rule=\"evenodd\"><path pid=\"0\" d=\"M6.3 0c1.3 0 2.5.4 3.5 1L5.9 7.7l-2.4 4.2C1.4 10.9 0 8.7 0 6.3 0 2.8 2.9 0 6.3 0z\" _fill=\"#70a4e3\"/><path pid=\"1\" d=\"M6.7 10.3l2.5-4.4.3-.3c.5-.3 1.1-.1 1.3.3l2.5 4.4 2.6 4.3c.1.2.1.3.1.5 0 .5-.4.9-.9.9h-10c-.2 0-.3 0-.5-.1-.4-.3-.6-.9-.3-1.3l2.4-4.3z\" _fill=\"#1067d1\"/></g>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "megui-menu-nav-active": {
          "name": "megui-menu-nav-active",
          "data": "<g fill-rule=\"evenodd\" clip-rule=\"evenodd\"><path pid=\"0\" d=\"M3.7 4v12H0V4h3.7zM16 0v2.7H0V0h16z\" _fill=\"#1067d1\"/><path pid=\"1\" d=\"M5.9 4H15c.6 0 1 .4 1 1v10c0 .6-.4 1-1 1H5.9c-.6 0-1-.4-1-1V5c0-.6.5-1 1-1z\" _fill=\"#70a4e3\"/></g>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "megui-menu-feedback-active": {
          "name": "megui-menu-feedback-active",
          "data": "<g fill-rule=\"evenodd\" clip-rule=\"evenodd\"><path pid=\"0\" d=\"M15.2 3.2h-1.6v8.5H3.2v1.6c0 .4.4.8.8.8h8.8L16 16V4c0-.4-.4-.8-.8-.8z\" _fill=\"#70a4e3\"/><path pid=\"1\" d=\"M12.7 9.8v-9c0-.4-.4-.8-.8-.8H.8C.4 0 0 .4 0 .8v12.6l3.2-2.7h8.7c.4-.1.8-.4.8-.9z\" _fill=\"#1067d1\"/></g>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "megui-menu-layout-active": {
          "name": "megui-menu-layout-active",
          "data": "<g fill-rule=\"evenodd\" clip-rule=\"evenodd\"><path pid=\"0\" d=\"M1.8 1.3c.6 0 1 .4 1 1v11.3c0 .6-.4 1-1 1H1c-.6 0-1-.4-1-1V2.3c0-.6.4-1 1-1h.8zm13.2 0c.6 0 1 .4 1 1v11.3c0 .6-.4 1-1 1h-.8c-.6 0-1-.4-1-1V2.3c0-.6.4-1 1-1h.8z\" _fill=\"#1067d1\"/><path pid=\"1\" d=\"M4.8 16h6.5c.6 0 1-.4 1-1V1c0-.6-.4-1-1-1H4.8c-.6 0-1 .4-1 1v14c0 .6.4 1 1 1z\" _fill=\"#70a4e3\"/></g>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "megui-menu-console-active": {
          "name": "megui-menu-console-active",
          "data": "<g fill-rule=\"evenodd\" clip-rule=\"evenodd\"><path pid=\"0\" d=\"M1.1 0h5.3C7 0 7.5.4 7.5 1v6c0 .6-.4 1-1.1 1H1.1C.4 8 0 7.6 0 7V1c0-.6.4-1 1.1-1z\" _fill=\"#1067d1\"/><path pid=\"1\" d=\"M9.7 0h5.2c.6 0 1 .5 1 1.1v3.4c0 .6-.5 1.1-1 1.1H9.7c-.6 0-1-.5-1-1.1V1.1c0-.6.4-1.1 1-1.1zM1.1 9.3h5.3c.6 0 1.1.5 1.1 1.1v3.4c0 .6-.5 1.1-1.1 1.1H1.1c-.6.1-1.1-.4-1.1-1v-3.4c0-.7.5-1.2 1.1-1.2z\" _fill=\"#70a4e3\"/><path pid=\"2\" d=\"M9.7 7h5.2c.6 0 1 .4 1 1v6c0 .6-.4 1-1 1H9.7c-.6 0-1-.4-1-1V8c0-.6.4-1 1-1z\" _fill=\"#1067d1\"/></g>",
          "viewBox": "0 0 16 15",
          "width": "16",
          "height": "15"
        },
        "megui-menu-display-active": {
          "name": "megui-menu-display-active",
          "data": "<g fill-rule=\"evenodd\" clip-rule=\"evenodd\"><path pid=\"0\" d=\"M15 5.3c.6 0 1 .4 1 1V15c0 .6-.4 1-1 1H1c-.6 0-1-.4-1-1V6.3c0-.6.4-1 1-1h14zm-2 6.1H2.3v1.9H13v-1.9zM7.6 8H2.3v1.9h5.3V8z\" _fill=\"#70a4e3\"/><path pid=\"1\" d=\"M1 0h14c.6 0 1 .4 1 1v2c0 .6-.4 1-1 1H1c-.6 0-1-.4-1-1V1c0-.6.4-1 1-1z\" _fill=\"#1067d1\"/></g>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "megui-menu-input-active": {
          "name": "megui-menu-input-active",
          "data": "<g fill-rule=\"evenodd\" clip-rule=\"evenodd\"><path pid=\"0\" d=\"M14.9 4.4S14.1.2 10 0c0 0 2.3 2.7 1.5 4.4H9.9l3 4.8 3-4.8h-1z\" _fill=\"#1067d1\"/><path pid=\"1\" d=\"M16 10.2v2.3H0V0h8.4v9.1c0 .6.5 1 1 1l6.6.1z\" _fill=\"#70a4e3\"/><path pid=\"2\" _fill=\"#1067d1\" d=\"M16 16H0v-2.6h16z\"/></g>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "megui-menu-charts-active": {
          "name": "megui-menu-charts-active",
          "data": "<g fill-rule=\"evenodd\" clip-rule=\"evenodd\"><path pid=\"0\" d=\"M7.3.5v8H15.6c0 4.2-3.6 7.5-7.8 7.5C3.4 16 0 12.7 0 8.4 0 4.2 3.1.5 7.3.5z\" _fill=\"#1067d1\"/><path pid=\"1\" d=\"M8.2 0C12.5 0 16 3.3 16 7.5H8.3h-.1V0z\" _fill=\"#70a4e3\"/></g>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "megui-pic-white": {
          "name": "megui-pic-white",
          "data": "<path pid=\"0\" d=\"M40.5.6c1.1 0 2 .9 2 2v29.8c0 1.1-.9 2-2 2h-38c-1.1 0-2-.9-2-2V2.6c0-1.1.9-2 2-2h38zm-14 13.7l-8 8-4.5-4.9-9.4 11h34.7L26.5 14.3zm-13-7.1c-2 0-3.5 1.6-3.5 3.5 0 2 1.6 3.5 3.5 3.5 2 0 3.5-1.6 3.5-3.5s-1.6-3.5-3.5-3.5z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#fff\"/>",
          "viewBox": "0 0 43 35",
          "width": "43",
          "height": "35"
        },
        "megui-table-sorter": {
          "name": "megui-table-sorter",
          "data": "<path pid=\"0\" d=\"M12.9 5.5l-4.7 5.4c-.1.2-.4.2-.5 0L3.1 5.5c-.2-.2 0-.5.2-.5h9.3c.3 0 .5.3.3.5z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#707078\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "megui-inputnumber-fill-down": {
          "name": "megui-inputnumber-fill-down",
          "data": "<path pid=\"0\" d=\"M11.9 6.4l-3.7 4.3c-.1.1-.3.1-.4 0L4.1 6.4c-.2-.2-.1-.4.2-.4h7.5c.2 0 .3.2.1.4z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#707078\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "megui-inputnumber-fill-up": {
          "name": "megui-inputnumber-fill-up",
          "data": "<path pid=\"0\" d=\"M4.1 10l3.7-4.3c.1-.1.3-.1.4 0l3.7 4.3c.1.2 0 .4-.2.4H4.3c-.3 0-.4-.2-.2-.4z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#707078\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "sound-off": {
          "name": "sound-off",
          "data": "<g fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#c9c9cb\"><path pid=\"0\" d=\"M7.2 2h-.3c-.3 0-.6.1-.7.3L3.3 5.7H2c-.6 0-1 .4-1 1V10c0 .6.4 1 1 1h1.3l2.8 2.7c.2.2.5.3.8.3h.3c.5 0 .8-.4.8-.8V2.7c0-.4-.3-.7-.8-.7zM12.7 8l2.1-2.2.1-.1c.1-.2.1-.4-.1-.6s-.5-.2-.7 0L12 7.2 9.8 5c-.2-.1-.5-.1-.6.2-.2.2-.2.5 0 .7L11.3 8l-2.1 2.1-.1.1c-.1.2-.1.4.1.6s.5.2.7 0L12 8.7l2.1 2.1.1.1c.2.1.4.1.6-.1s.2-.5 0-.7L12.7 8z\"/></g>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "sound-on": {
          "name": "sound-on",
          "data": "<g fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#74747d\"><path pid=\"0\" d=\"M7.2 2h-.4c-.2 0-.5.1-.7.3L3.2 5.7H1.9c-.6 0-1 .4-1 1v3.4c0 .6.4 1 1 1h1.4l2.8 2.7c.2.2.5.3.8.3h.3c.5 0 .8-.4.8-.8V2.8c0-.5-.4-.8-.8-.8zM11.8 2.8c-.3-.1-.6-.1-.7.2-.1.3 0 .6.2.7C12.9 4.4 14 6.1 14 8c0 1.7-.9 3.3-2.3 4.1-.2.2-.3.5-.2.7.2.2.5.3.7.2 1.8-1 2.9-2.9 2.9-5 0-2.3-1.3-4.3-3.3-5.2z\"/><path pid=\"1\" d=\"M10.5 5.6c-.2-.2-.6-.1-.7.2-.1.2-.1.5.1.7.4.4.7 1 .7 1.6 0 .6-.3 1.2-.8 1.6-.2.2-.3.5-.1.7.2.2.5.3.7.1.7-.6 1.2-1.5 1.2-2.5s-.4-1.8-1.1-2.4z\"/></g><image width=\"2174\" height=\"474\" xlink:href=\"27B10F46DB734B8.png\" transform=\"translate(-148.364 19.249) scale(.1757)\" overflow=\"visible\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "cloud-upload": {
          "name": "cloud-upload",
          "data": "<path pid=\"0\" d=\"M47.5 17.6c0-.1 0-.1 0 0C47.5 7.9 39.7 0 30 0S12.5 7.8 12.5 17.5v.1C5.5 18.2 0 24.1 0 31.3c0 7.6 6.2 13.8 13.8 13.8H25V35H14.6L30 17.5 44.9 35H35v10h11.2C53.8 45 60 38.8 60 31.2c0-7.1-5.5-13-12.5-13.6z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#181725\" opacity=\".2\"/>",
          "viewBox": "0 0 60 45",
          "width": "60",
          "height": "45"
        },
        "megui-transfer": {
          "name": "megui-transfer",
          "data": "<path pid=\"0\" d=\"M12.839 9.5a.5.5 0 01.09.992l-.09.008H4.147l1.764 1.582a.5.5 0 01.092.634l-.054.072a.5.5 0 01-.634.093l-.072-.054-2.543-2.28a.6.6 0 01.303-1.04L3.1 9.5h9.739zm-2.316-5.926l.072.054 2.544 2.28a.6.6 0 01-.303 1.039l-.097.008H3a.5.5 0 01-.09-.992L3 5.955l8.692-.001-1.764-1.582a.5.5 0 01-.093-.633l.054-.073a.5.5 0 01.634-.092z\" _fill=\"#707078\" fill-rule=\"evenodd\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "megui-download": {
          "name": "megui-download",
          "data": "<path pid=\"0\" d=\"M14.4 10.9c.3 0 .5.2.6.5v2.4c0 .6-.5 1.1-1.1 1.2H2.2c-.6 0-1.2-.5-1.2-1.1v-2.4c0-.3.3-.6.6-.6s.5.2.6.5v2.4h11.7v-2.3c-.1-.3.2-.6.5-.6zM8 1c.3 0 .5.2.6.5v8.2l3.7-3.3c.2-.2.6-.2.8 0 .2.2.2.6 0 .8l-.1.1-5 4.5-5.1-4.5c-.2-.2-.3-.6 0-.8.2-.2.5-.3.8-.1h.1l3.7 3.3V1.6c-.1-.3.2-.6.5-.6z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#707078\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "upload": {
          "name": "upload",
          "data": "<path pid=\"0\" d=\"M14.4 10.9c.3 0 .5.2.6.5v2.4c0 .6-.5 1.1-1.1 1.2H2.2c-.6 0-1.2-.5-1.2-1.1v-2.4c0-.3.3-.6.6-.6s.5.2.6.5v2.4h11.7v-2.3c-.1-.3.2-.6.5-.6zM8 1l5 4.5c.2.2.3.6 0 .8-.2.2-.5.3-.8.1h-.1L8.6 3.1v7.5c0 .3-.3.6-.6.6s-.5-.2-.6-.5V3.1L3.7 6.4c-.2.2-.6.2-.8 0-.2-.2-.2-.6 0-.8l.1-.1L8 1z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#707078\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "Down": {
          "name": "Down",
          "data": "<path pid=\"0\" d=\"M3.2 4.1H2c-.1 0-.2.1-.1.2l5.5 7.1c.2.3.6.3.8 0l5.5-7.1c.1-.1 0-.2-.1-.2h-1.2c-.1 0-.1 0-.2.1L7.8 9.9 3.4 4.2c-.1 0-.1-.1-.2-.1z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#707078\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "copy": {
          "name": "copy",
          "data": "<path pid=\"0\" d=\"M13 4c.6 0 1 .4 1 1v8c0 .6-.4 1-1 1H5c-.6 0-1-.4-1-1V5c0-.6.4-1 1-1h8zm-1.4-2c.8 0 1.5.6 1.6 1.5v.1H12c0-.2-.1-.4-.3-.4H3.6c-.2 0-.4.1-.4.3v8.1c0 .2.1.4.3.4h.1v1.2c-.8 0-1.5-.6-1.6-1.5V3.6c0-.8.6-1.5 1.5-1.6h8.1zm1.2 3.2H5.2v7.6h7.6V5.2z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#707078\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "megui-subordinate": {
          "name": "megui-subordinate",
          "data": "<path pid=\"0\" d=\"M6 1c.6 0 1 .4 1 1v2c0 .6-.4 1-1 1H4.6v2.4H9V7c0-.6.4-1 1-1h4c.6 0 1 .4 1 1v2c0 .6-.4 1-1 1h-4c-.6 0-1-.4-1-1v-.4H4.6V12c0 .2.1.4.3.4H9V12c0-.6.4-1 1-1h4c.6 0 1 .4 1 1v2c0 .6-.4 1-1 1h-4c-.6 0-1-.4-1-1v-.4H5c-.8 0-1.5-.6-1.6-1.5V5H2c-.6 0-1-.4-1-1V2c0-.6.4-1 1-1h4zm7.8 11.2h-3.6v1.6h3.6v-1.6zm0-5h-3.6v1.6h3.6V7.2zm-8-5H2.2v1.6h3.6V2.2z\" _fill=\"#1067d1\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "megui-fill-tag": {
          "name": "megui-fill-tag",
          "data": "<path pid=\"0\" d=\"M7.3 6V1C3.8 1.4 1 4.4 1 8s2.8 6.6 6.3 7v-5c-.7-.3-1.4-1.1-1.4-2s.7-1.7 1.4-2zM10 7.3h5c-.3-3.3-2.8-6-6.3-6.3v5c.7.2 1.1.7 1.3 1.3zM8.7 10v5c3.5-.3 6-3 6.3-6.3h-5c-.2.6-.6 1.1-1.3 1.3z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#707078\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "megui-add": {
          "name": "megui-add",
          "data": "<g _fill=\"#707078\" fill-rule=\"evenodd\"><path pid=\"0\" d=\"M8.008 2.996c.285 0 .52.238.552.545l.003.072v3.829h3.83c.34 0 .617.25.617.556 0 .285-.238.52-.545.552l-.072.004-3.83-.001v3.83c0 .341-.248.618-.555.618-.285 0-.52-.239-.552-.546l-.004-.072v-3.83h-3.83c-.34 0-.616-.248-.616-.555 0-.285.238-.52.545-.552l.072-.003 3.829-.001V3.613c0-.34.25-.617.556-.617z\"/><path pid=\"1\" d=\"M8 1.954a.6.6 0 01.6.6l-.001 4.8H13.4a.6.6 0 010 1.2H8.599l.001 4.8a.6.6 0 01-1.2 0v-4.8H2.6a.6.6 0 110-1.2h4.8v-4.8a.6.6 0 01.6-.6z\"/></g>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "megui-fill-close-circle": {
          "name": "megui-fill-close-circle",
          "data": "<path pid=\"0\" d=\"M8 1C4.1 1 1 4.1 1 8s3.1 7 7 7 7-3.1 7-7-3.1-7-7-7zm2.6 9.7h-1L8 8.8l-1.6 1.8h-1c-.1 0-.1-.1-.1-.1v-.1l2-2.4-2-2.4v-.1c0-.1.1-.1.1-.1h1L8 7.3l1.6-1.8h1c.1 0 .1.1.1.1v.1L8.6 8l2 2.4v.1c.1.1.1.2 0 .2z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#707078\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "megui-fill-warn": {
          "name": "megui-fill-warn",
          "data": "<path pid=\"0\" d=\"M8 15c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7zm0-5.8c.3 0 .6-.3.6-.6v-4c0-.3-.3-.5-.6-.5s-.6.3-.6.6v4c.1.2.3.5.6.5zm0 2.3c.4 0 .8-.3.8-.8S8.4 10 8 10s-.8.3-.8.8.4.7.8.7z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#707078\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "megui-fill-check-circle": {
          "name": "megui-fill-check-circle",
          "data": "<path pid=\"0\" d=\"M8 1C4.1 1 1 4.1 1 8s3.1 7 7 7 7-3.1 7-7-3.1-7-7-7zm3 4.7l-3.3 4.6c-.2.3-.6.3-.8 0L5 7.6c-.1-.1 0-.2.1-.2h.7c.2 0 .3.1.4.2l1.1 1.5 2.5-3.4c.1-.1.2-.2.4-.2h.7c.1 0 .2.1.1.2z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#707078\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "close-circle": {
          "name": "close-circle",
          "data": "<path pid=\"0\" d=\"M8 1c3.9 0 7 3.1 7 7s-3.1 7-7 7-7-3.1-7-7 3.1-7 7-7zm0 1.2C4.8 2.2 2.2 4.8 2.2 8s2.6 5.8 5.8 5.8 5.8-2.6 5.8-5.8S11.2 2.2 8 2.2zm2.3 3.5c.1 0 .1.1.1.1v.1L8.6 8.1l1.8 2.2v.1c0 .1-.1.1-.1.1h-.9L8 8.8l-1.4 1.7h-.9c-.1 0-.1-.1-.1-.1v-.1l1.8-2.2-1.8-2.2v-.1c0-.1.1-.1.1-.1h.9L8 7.4l1.4-1.7h.9z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#707078\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "file": {
          "name": "file",
          "data": "<path pid=\"0\" d=\"M11.687 10.926a.5.5 0 01.506.493.5.5 0 01-.506.494H5.61a.5.5 0 01-.506-.494.5.5 0 01.506-.493zm0-2.962a.5.5 0 01.506.494.5.5 0 01-.506.493H5.61a.5.5 0 01-.506-.493.5.5 0 01.506-.494zM10.357 0c.52.002.708.009.784.012h.024l4.132 3.974v9.9a2.01 2.01 0 01-.613 1.444 2.106 2.106 0 01-1.264.586l-.214.01H4.091c-.577 0-1.1-.227-1.478-.596a2.014 2.014 0 01-.602-1.235L2 13.888V2.04c0-.564.234-1.074.613-1.444A2.107 2.107 0 013.878.011L4.09 0h6.265zM4.09 1.119l-.153.012a.954.954 0 00-.517.259.907.907 0 00-.277.65v11.848l.013.149a.911.911 0 00.264.502c.172.167.409.27.67.27h9.115l.154-.012c.2-.032.379-.125.516-.258a.908.908 0 00.277-.651v-8.82h-1.96l-.214-.01a2.088 2.088 0 01-1.269-.597 2.069 2.069 0 01-.61-1.475 80.592 80.592 0 01-.012-1.867H4.09zm7.155.363v1.546l.012.149a.911.911 0 00.265.502c.171.167.408.27.67.27h1.57l-2.517-2.467z\" _fill=\"#1067D1\" fill-rule=\"nonzero\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "video-status": {
          "name": "video-status",
          "data": "<path pid=\"0\" fill-rule=\"evenodd\" _fill=\"#0F0\" d=\"M21 14a7 7 0 110 14 7 7 0 010-14z\"/>",
          "viewBox": "0 0 43 43",
          "width": "43",
          "height": "43"
        },
        "megui-back-top": {
          "name": "megui-back-top",
          "data": "<path pid=\"0\" d=\"M18 .5v2.571H0V.5h18zM.721 12.566l8.235-8.624 8.235 8.624-1.86 1.776-6.376-6.677-6.374 6.677-1.86-1.776z\" _fill=\"#181725\" fill-rule=\"evenodd\" fill-opacity=\".6\"/>",
          "viewBox": "0 0 18 15",
          "width": "18",
          "height": "15"
        },
        "megui-back-top-new": {
          "name": "megui-back-top-new",
          "data": "<path pid=\"0\" d=\"M18 .5v2.571H0V.5h18zM.721 12.566l8.235-8.624 8.235 8.624-1.86 1.776-6.376-6.677-6.374 6.677-1.86-1.776z\" _fill=\"#181725\" fill-rule=\"evenodd\"/>",
          "viewBox": "0 0 18 15",
          "width": "18",
          "height": "15"
        },
        "megui-ellipse": {
          "name": "megui-ellipse",
          "data": "<path pid=\"0\" d=\"M3 8.25a1.25 1.25 0 112.5 0 1.25 1.25 0 01-2.5 0zm4 0a1.25 1.25 0 112.5 0 1.25 1.25 0 01-2.5 0zm4 0a1.25 1.25 0 112.5 0 1.25 1.25 0 01-2.5 0z\" _fill=\"#1067D1\" fill-rule=\"evenodd\"></path>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "megui-star": {
          "name": "megui-star",
          "data": "<path pid=\"0\" d=\"M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 00.6 45.3l183.7 179.1-43.4 252.9a31.95 31.95 0 0046.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3z\"/>",
          "viewBox": "64 64 896 896",
          "width": "896",
          "height": "896"
        },
        "table-empty": {
          "name": "table-empty",
          "data": "<g _fill=\"#EEEEF4\" fill-rule=\"evenodd\"><path pid=\"0\" d=\"M56.626 18.177L71.76 43.703v29.2H0v-29.2l15.141-25.526h41.485zm-2.6 4.19H17.725L5 43.814V48h20.088c1.896 4.131 6.07 7 10.912 7 4.843 0 9.016-2.869 10.912-7H67v-4.185L54.026 22.366zM53.189 1.772a1.5 1.5 0 012.686 1.327l-.064.13-5 9a1.5 1.5 0 01-2.686-1.328l.064-.13 5-9zM17.811 1.772a1.5 1.5 0 00-2.686 1.327l.064.13 5 9a1.5 1.5 0 002.686-1.328l-.064-.13-5-9zM35.5 0a1.5 1.5 0 011.493 1.356L37 1.5v10a1.5 1.5 0 01-2.993.144L34 11.5v-10A1.5 1.5 0 0135.5 0z\"/></g>",
          "viewBox": "0 0 72 73",
          "width": "72",
          "height": "73"
        },
        "megui-lock": {
          "name": "megui-lock",
          "data": "<path pid=\"0\" d=\"M8 1.4c2.2 0 3.9 1.8 3.9 3.9V6h.1c.7 0 1.2.5 1.3 1.1v6.1c0 .7-.6 1.3-1.3 1.3H4c-.7 0-1.3-.6-1.3-1.3v-6c0-.7.6-1.3 1.3-1.3h.1v-.7c0-2.1 1.7-3.8 3.7-3.9l.2.1zm4 5.9H4s-.1 0-.1.1v6s0 .1.1.1h8s.1 0 .1-.1L12 7.3c.1 0 0 0 0 0zM8 8.7c.3 0 .6.2.6.5v2.1c0 .3-.3.6-.6.6s-.6-.2-.6-.5V9.3c0-.3.3-.6.6-.6zm0-6.1c-1.5 0-2.7 1.2-2.7 2.7V6h5.5v-.7c0-1.5-1.2-2.7-2.6-2.7H8z\" _fill=\"#75747d\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "megui-layout-menu": {
          "name": "megui-layout-menu",
          "data": "<path pid=\"0\" d=\"M5.942 5.95h5.333v5.334H5.942V5.951zm0 7.556h5.333v5.334H5.942v-5.334zm0 7.556h5.333v5.333H5.942v-5.333zm7.555-15.111h5.334v5.333h-5.334V5.951zm0 7.555h5.334v5.334h-5.334v-5.334zm0 7.556h5.334v5.333h-5.334v-5.333zm7.556-7.556h5.333v5.334h-5.333v-5.334zm0 7.556h5.333v5.333h-5.333v-5.333zm0-15.111h5.333v5.333h-5.333V5.951z\" _fill=\"#F1F1F1\" fill-rule=\"evenodd\"/>",
          "viewBox": "0 0 32 32",
          "width": "32",
          "height": "32"
        },
        "megui-upload-error": {
          "name": "megui-upload-error",
          "data": "<path pid=\"0\" d=\"M20.917 3.837c.828 0 1.5.616 1.5 1.375v13.75c0 .128-.02.25-.055.368l.055.054-.108.09c-.168.383-.517.68-.951.803l-.073.06-.036-.033a1.636 1.636 0 01-.332.033h-18c-.829 0-1.5-.615-1.5-1.375V5.212c0-.759.671-1.375 1.5-1.375h18zM7.87 11.992L2.917 16.49v2.473h16.975l-4.679-4.62-3.442 2.541-3.901-4.89zm13.047-6.78h-18v9.295l5.141-4.67 4.006 5.023 3.302-2.438 5.55 5.48V5.212zm-3.75 1.625a2.25 2.25 0 110 4.5 2.25 2.25 0 010-4.5zm0 1.5a.75.75 0 100 1.5.75.75 0 000-1.5z\" _fill=\"#E53635\" fill-rule=\"evenodd\"/>",
          "viewBox": "0 0 24 24",
          "width": "24",
          "height": "24"
        },
        "megui-upload-trash": {
          "name": "megui-upload-trash",
          "data": "<path pid=\"0\" d=\"M14 3.067a.6.6 0 01.075 1.195L14 4.267l-.734-.001v8.4c0 1.018-.784 1.851-1.782 1.928l-.15.006H4.666a1.933 1.933 0 01-1.934-1.933V4.266H2a.6.6 0 01-.075-1.195L2 3.067h12zm-1.933 1.2H3.933v8.4c0 .378.286.689.654.729l.08.004h6.666a.733.733 0 00.734-.733v-8.4zM6.667 6.4a.6.6 0 01.595.525L7.267 7v4a.6.6 0 01-1.196.075L6.067 11V7a.6.6 0 01.6-.6zm2.666 0a.6.6 0 01.596.525L9.933 7v4a.6.6 0 01-1.195.075L8.733 11V7a.6.6 0 01.6-.6zm.667-5a.6.6 0 01.075 1.195L10 2.6H6a.6.6 0 01-.075-1.195L6 1.4h4z\" _fill=\"#FFF\" fill-rule=\"nonzero\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "megui-up": {
          "name": "megui-up",
          "data": "<path pid=\"0\" _fill=\"#181725\" fill-opacity=\".01\" d=\"M0 0h16v16H0z\"/><path pid=\"1\" d=\"M2.3 11.4c-.3-.2-.3-.5-.1-.7v-.1l5.3-6c.2-.2.6-.3.8-.1l.1.1 5.3 6c.2.2.2.6 0 .8-.2.2-.6.2-.8 0l-.1-.1L8 5.9l-4.9 5.5c-.2.2-.5.3-.8 0z\" _fill=\"#75747d\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "megui-fill-info": {
          "name": "megui-fill-info",
          "data": "<path pid=\"0\" id=\"\u5F62\u72B6\u7ED3\u5408\" d=\"M8 1c3.9 0 7 3.1 7 7s-3.1 7-7 7-7-3.1-7-7 3.1-7 7-7zm0 5.8c-.3 0-.6.3-.6.6v4c0 .3.3.5.6.5s.6-.3.6-.6v-4c-.1-.2-.3-.5-.6-.5zm0-2.3c-.4 0-.8.3-.8.8s.4.7.8.7.8-.3.8-.8-.4-.7-.8-.7z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#181725\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "megui-loading": {
          "name": "megui-loading",
          "data": "<g _fill=\"#1067D1\" fill-rule=\"evenodd\"><path pid=\"0\" d=\"M24 0c13.255 0 24 10.745 24 24S37.255 48 24 48 0 37.255 0 24 10.745 0 24 0zm0 4C12.954 4 4 12.954 4 24s8.954 20 20 20 20-8.954 20-20S35.046 4 24 4z\" fill-opacity=\".1\"/><path pid=\"1\" d=\"M24 0c13.255 0 24 10.745 24 24a2 2 0 11-4 0c0-11.046-8.954-20-20-20S4 12.954 4 24s8.954 20 20 20a2 2 0 110 4C10.745 48 0 37.255 0 24S10.745 0 24 0z\"/></g>",
          "viewBox": "0 0 48 48",
          "width": "48",
          "height": "48"
        },
        "megui-pic-black": {
          "name": "megui-pic-black",
          "data": "<path pid=\"0\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" _fill=\"#181725\" fill-opacity=\".01\" d=\"M0 0h16v16H0z\"/><path pid=\"1\" d=\"M14.6 12.8c0 .6-.5 1.1-1.1 1.2H2.4c-.6-.1-1.1-.5-1.1-1.2V3.3c0-.7.5-1.3 1.2-1.3h10.7c.7 0 1.2.6 1.2 1.3v9.5zm-5.9-4l-1.5 1.6c-.2.2-.5.2-.8.1l-1.2-.9-2.6 2.3V12.7h10.7V11.9L8.7 8.8zm4.7-5.5H2.6v7.1l2.2-1.9c.2-.2.4-.2.7-.1l.1.1 1.2.8 1.5-1.6c.1-.3.4-.4.7-.2l4.4 3V3.3zm-8.9.8c.6 0 1.1.5 1.1 1.1s-.5 1.1-1.1 1.1-1.1-.5-1.1-1.1.5-1.1 1.1-1.1z\" _fill=\"#74747d\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "megui-search": {
          "name": "megui-search",
          "data": "<path pid=\"0\" d=\"M7 1.4a5.6 5.6 0 014.362 9.113l2.396 2.396a.6.6 0 01-.787.902l-.062-.053-2.396-2.396A5.6 5.6 0 117 1.4zm0 1.2a4.4 4.4 0 100 8.8 4.4 4.4 0 000-8.8z\" _fill=\"#181725\" fill-rule=\"nonzero\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "megui-basicdata-management": {
          "name": "megui-basicdata-management",
          "data": "<path pid=\"0\" d=\"M896 879.104a35.84 35.84 0 014.864 71.373l-4.864.307H128a35.84 35.84 0 01-4.864-71.322l4.864-.358h768zM238.08 263.168a81.92 81.92 0 0181.92 81.92v369.51a81.92 81.92 0 01-81.92 81.92h-28.16a81.92 81.92 0 01-81.92-81.92V345.037a81.92 81.92 0 0181.92-81.92h28.16zm288-177.766a81.92 81.92 0 0181.92 81.92v547.276a81.92 81.92 0 01-81.92 81.92h-28.16a81.92 81.92 0 01-81.92-81.92V167.22a81.92 81.92 0 0181.92-81.92h28.16zm288 133.222a81.92 81.92 0 0181.92 81.92v413.952a81.92 81.92 0 01-81.92 81.92h-28.16a81.92 81.92 0 01-81.92-81.92V300.544a81.92 81.92 0 0181.92-81.92h28.16zm-576 100.813h-28.16a25.6 25.6 0 00-25.19 20.992l-.41 4.608v369.51a25.6 25.6 0 0020.992 25.19l4.608.41h28.16a25.6 25.6 0 0025.19-20.992l.41-4.608v-369.51a25.6 25.6 0 00-20.992-25.19l-4.608-.41zm288-177.767h-28.16a25.6 25.6 0 00-25.19 20.992l-.41 4.608v547.277a25.6 25.6 0 0020.992 25.19l4.608.41h28.16a25.6 25.6 0 0025.19-20.992l.41-4.608V167.22a25.6 25.6 0 00-20.992-25.139l-4.608-.41zm288 133.274h-28.16a25.6 25.6 0 00-25.19 20.992l-.41 4.608v413.952a25.6 25.6 0 0020.992 25.19l4.608.41h28.16a25.6 25.6 0 0025.19-20.992l.41-4.608V300.544a25.6 25.6 0 00-20.992-25.19l-4.608-.41z\"/>",
          "viewBox": "0 0 1024 1024",
          "width": "1024",
          "height": "1024"
        },
        "megui-count-management": {
          "name": "megui-count-management",
          "data": "<path pid=\"0\" d=\"M665.6 563.2a153.6 153.6 0 01127.488 239.309l67.789 69.683a30.72 30.72 0 01-39.783 46.49l-4.198-3.584-67.584-69.479A153.6 153.6 0 11665.6 563.2zM550.246 84.07l7.732 5.018L915.866 340.48a35.84 35.84 0 01-36.608 61.338l-4.608-2.714-11.008-7.782v108.032a35.84 35.84 0 01-71.373 4.864l-.307-4.864V345.6l.256-4.403-275.456-193.485a46.08 46.08 0 00-47.463-3.277l-5.478 3.277-282.317 198.4c3.584 4.762 5.99 10.445 6.86 16.64l.308 4.864v423.27a46.08 46.08 0 0040.294 45.722l5.786.358h255.54a35.84 35.84 0 014.863 71.373l-4.864.307H234.752a117.76 117.76 0 01-117.504-109.67l-.256-8.09V391.322l-11.06 7.782a35.84 35.84 0 01-45.311-55.296l4.096-3.38 357.888-251.39a117.76 117.76 0 01127.641-4.967zM665.6 624.64a92.16 92.16 0 100 184.32 92.16 92.16 0 000-184.32zm-85.3-248.986a35.84 35.84 0 014.865 71.373l-4.864.307H400.384a35.84 35.84 0 01-4.864-71.321l4.864-.359h179.968z\"/>",
          "viewBox": "0 0 1024 1024",
          "width": "1024",
          "height": "1024"
        },
        "megui-delivery-management": {
          "name": "megui-delivery-management",
          "data": "<path pid=\"0\" d=\"M572.109 84.326l7.782 5.12 379.443 267.776a35.84 35.84 0 01-36.761 61.287l-4.608-2.714-14.592-10.393v81.51a35.84 35.84 0 01-71.322 4.864l-.358-4.864V361.421c0-2.1.205-4.147.512-6.144l-293.632-207.36a46.08 46.08 0 00-47.616-3.277l-5.53 3.328-293.171 206.848v501.862a46.08 46.08 0 0040.346 45.722l5.785.358h547.226a46.08 46.08 0 0045.721-40.294l.359-5.786V807.68a35.84 35.84 0 0171.373-4.864l.307 4.864v48.998a117.76 117.76 0 01-109.67 117.504l-8.09.256H238.387a117.76 117.76 0 01-117.504-109.67l-.256-8.09-.051-451.276-14.592 10.342A35.84 35.84 0 0160.57 360.55l4.096-3.379L444.058 89.395a117.76 117.76 0 01128.05-5.12zM766.925 531.15l4.403 2.97 94.822 75.263a35.84 35.84 0 014.096 52.327l-4.096 3.84-94.822 75.264a35.84 35.84 0 01-48.486-52.48l3.89-3.584 14.337-11.469-323.891.051a35.84 35.84 0 01-4.864-71.373l4.864-.307h323.89l-14.335-11.366a35.84 35.84 0 01-8.704-45.978l2.918-4.403a35.84 35.84 0 0145.978-8.755zM606.822 350.67a35.84 35.84 0 014.864 71.373l-4.864.307H417.178a35.84 35.84 0 01-4.864-71.373l4.864-.307h189.644z\"/>",
          "viewBox": "0 0 1024 1024",
          "width": "1024",
          "height": "1024"
        },
        "megui-entry-management": {
          "name": "megui-entry-management",
          "data": "<path pid=\"0\" d=\"M572.16 84.326l7.782 5.12 379.392 267.776a35.84 35.84 0 01-36.761 61.338l-4.557-2.765-14.643-10.393v200.396a117.76 117.76 0 01-109.67 117.453l-8.039.307H543.693l14.336 11.367a35.84 35.84 0 018.704 45.977l-2.97 4.404a35.84 35.84 0 01-45.926 8.704l-4.403-2.97-94.823-75.264a35.84 35.84 0 01-4.096-52.275l4.096-3.84 94.823-75.315a35.84 35.84 0 0148.486 52.53l-3.891 3.585-14.439 11.366h242.074a46.08 46.08 0 0045.722-40.243l.358-5.786V361.421c0-2.048.154-4.147.512-6.144L538.573 147.968a46.08 46.08 0 00-47.616-3.328l-5.53 3.328-293.632 207.36a35.789 35.789 0 01.154 1.229l.358 4.864v495.36a46.08 46.08 0 0040.295 45.721l5.785.359h547.277a46.08 46.08 0 0045.722-40.295l.358-5.785V813.21a35.84 35.84 0 0171.322-4.864l.358 4.864v43.52a117.76 117.76 0 01-109.722 117.504l-8.038.307H238.336a117.76 117.76 0 01-117.453-109.722l-.256-8.038-.051-451.328-14.54 10.342a35.84 35.84 0 01-45.466-55.193l4.096-3.38L444.109 89.446a117.76 117.76 0 01128-5.12zm34.662 291.482a35.84 35.84 0 014.864 71.322l-4.864.358H417.178a35.84 35.84 0 01-4.864-71.373l4.864-.307h189.644z\"/>",
          "viewBox": "0 0 1024 1024",
          "width": "1024",
          "height": "1024"
        },
        "megui-exit-fullscreen": {
          "name": "megui-exit-fullscreen",
          "data": "<path pid=\"0\" d=\"M432 568h.544c.64 0 1.28.064 1.92.128l.8.096a23.936 23.936 0 0115.968 9.408l-2.24-2.592A24.096 24.096 0 01456 592v160l-.224 3.264A24 24 0 01432 776l-3.264-.224A24 24 0 01408 752V649.92L288.96 768.96a24 24 0 01-36.256-31.232l2.336-2.688L374.016 616H272l-3.264-.224A24 24 0 01272 568h160zm152-320l3.264.224A24 24 0 01608 272l-.032 104.704L729.696 255.04a24 24 0 0136.256 31.232l-2.336 2.688L644.576 408H744l3.264.224A24 24 0 01744 456H584l-3.264-.224A24 24 0 01560 432V272l.224-3.264A24 24 0 01584 248z\"/>",
          "viewBox": "0 0 1024 1024",
          "width": "1024",
          "height": "1024"
        },
        "megui-fullscreen": {
          "name": "megui-fullscreen",
          "data": "<path pid=\"0\" d=\"M752 568a24 24 0 0123.776 20.736L776 592v160a24 24 0 01-20.736 23.776L752 776H592a24 24 0 01-3.264-47.776L592 728h136V592a24 24 0 0120.736-23.776L752 568zm-480 0a24 24 0 0123.776 20.736L296 592v102.016L415.04 575.04a24 24 0 0136.256 31.232l-2.336 2.688L329.92 728H432a24 24 0 0123.776 20.736L456 752a24 24 0 01-20.736 23.776L432 776H271.104a24.128 24.128 0 01-1.472-.128L272 776a24.128 24.128 0 01-19.232-9.632l2.24 2.592a24.096 24.096 0 01-6.784-13.696L248 752V592a24 24 0 0124-24zm160-320a24 24 0 013.264 47.776L432 296H296v136a24 24 0 01-20.736 23.776L272 456a24 24 0 01-23.776-20.736L248 432V272a24 24 0 0120.736-23.776L272 248h160zm320 0a24 24 0 0123.776 20.736L776 272v160a24 24 0 01-47.776 3.264L728 432V324.576L603.616 448.96a24 24 0 01-36.256-31.232l2.336-2.688L688.672 296H592a24 24 0 01-23.776-20.736L568 272a24 24 0 0120.736-23.776L592 248h160z\"/>",
          "viewBox": "0 0 1024 1024",
          "width": "1024",
          "height": "1024"
        },
        "megui-library-management": {
          "name": "megui-library-management",
          "data": "<path pid=\"0\" d=\"M762.624 587.264c23.552 0 42.65 19.098 42.7 42.65v8.755c15.77 5.478 30.209 13.67 42.702 24.064l9.216-5.171a42.65 42.65 0 0157.702 15.462l1.536 2.611a42.7 42.7 0 01-10.24 55.194l-5.478 3.686-7.68 4.352a129.485 129.485 0 010 48.128l7.68 4.352a42.7 42.7 0 0118.688 52.89l-2.97 5.99-1.536 2.663a42.65 42.65 0 01-57.651 15.462l-9.267-5.222a135.68 135.68 0 01-42.701 24.064V896a42.752 42.752 0 01-42.701 42.65h-4.66a42.65 42.65 0 01-42.342-37.274l-.307-5.376v-8.755a135.68 135.68 0 01-42.752-24.115l-9.216 5.222a42.65 42.65 0 01-57.702-15.462l-1.536-2.663a42.7 42.7 0 0110.24-55.142l5.478-3.738 7.68-4.352a129.485 129.485 0 010-48.128l-7.68-4.352a42.7 42.7 0 01-18.688-52.89l2.919-5.99 1.638-2.662a42.65 42.65 0 0157.6-15.463l9.318 5.223a135.68 135.68 0 0142.701-24.064v-8.755c0-21.76 16.23-39.732 37.274-42.343l5.376-.358h4.659zM550.246 84.07l7.732 5.018L915.866 340.48a35.84 35.84 0 01-36.608 61.338l-4.608-2.714-11.008-7.782v108.032a35.84 35.84 0 01-71.373 4.864l-.307-4.864V345.6l.256-4.403-275.456-193.485a46.08 46.08 0 00-47.463-3.277l-5.478 3.277-282.317 198.4c3.584 4.762 5.99 10.445 6.86 16.64l.308 4.864v423.27a46.08 46.08 0 0040.294 45.722l5.786.358h255.54a35.84 35.84 0 014.863 71.373l-4.864.307H234.752a117.76 117.76 0 01-117.504-109.67l-.256-8.09V391.322l-11.06 7.782a35.84 35.84 0 01-45.311-55.296l4.096-3.38 357.888-251.39a117.76 117.76 0 01127.641-4.967zM760.32 695.296l-22.733 7.834a67.584 67.584 0 00-14.694 7.168l-6.554 4.812-17.613 14.644-4.096 21.76a60.518 60.518 0 00-.819 5.632l-.256 5.734.256 5.786.82 5.632 4.095 21.657 17.613 14.746c4.147 3.481 8.704 6.451 13.67 8.806l7.578 3.123 22.733 7.834 22.733-7.834a67.584 67.584 0 0014.643-7.168l6.554-4.761 17.612-14.746 4.096-21.657c.359-1.844.615-3.738.768-5.632l.308-5.786-.308-5.734-.768-5.632-4.096-21.71-17.612-14.694a67.226 67.226 0 00-13.62-8.806l-7.577-3.174-22.733-7.834zM580.3 375.603a35.84 35.84 0 014.865 71.373l-4.864.307H400.384a35.84 35.84 0 01-4.864-71.321l4.864-.359h179.968z\"/>",
          "viewBox": "0 0 1024 1024",
          "width": "1024",
          "height": "1024"
        },
        "megui-system-management": {
          "name": "megui-system-management",
          "data": "<path pid=\"0\" d=\"M762.01 534.58c23.552 0 42.65 19.148 42.7 42.7v9.728c15.872 5.632 30.362 13.978 42.855 24.576l9.165-5.171a42.65 42.65 0 0158.06 15.565l2.253 3.89a42.7 42.7 0 01-10.598 55.092l-5.069 3.38-8.55 4.914a133.99 133.99 0 010 49.05l8.55 4.915c18.74 10.752 26.266 33.536 18.33 53.043l-2.663 5.479-2.253 3.891a42.65 42.65 0 01-58.06 15.565l-9.165-5.223a135.782 135.782 0 01-42.855 24.576v9.728a42.752 42.752 0 01-42.7 42.701h-5.12a42.65 42.65 0 01-42.292-37.325l-.358-5.324v-9.78a135.782 135.782 0 01-42.906-24.576l-9.113 5.223a42.65 42.65 0 01-58.061-15.565l-2.253-3.891a42.7 42.7 0 0110.599-55.091l5.068-3.43 8.55-4.916a133.99 133.99 0 010-49.05l-8.55-4.915a42.7 42.7 0 01-18.38-52.992l2.713-5.478 2.304-3.943a42.65 42.65 0 0158.01-15.564l9.216 5.222a136.27 136.27 0 0142.803-24.576v-9.728c0-21.76 16.282-39.731 37.376-42.342l5.325-.359h5.069zM736.717 92.16A117.76 117.76 0 01854.22 201.882l.256 8.038v234.291a35.84 35.84 0 01-71.373 4.864l-.307-4.864V209.92a46.08 46.08 0 00-40.295-45.722l-5.785-.358H252.57a46.08 46.08 0 00-45.722 40.294l-.358 5.786v559.002a46.08 46.08 0 0040.294 45.721l5.786.359h242.073a35.84 35.84 0 014.864 71.321l-4.864.359H252.57A117.76 117.76 0 01135.117 776.96l-.307-8.038V209.92A117.76 117.76 0 01244.53 92.416l8.039-.256h484.147zm22.681 551.322l-22.528 7.987a67.38 67.38 0 00-14.745 7.27l-6.605 4.915-18.074 15.258-4.25 22.835a64.973 64.973 0 00-.818 5.94l-.256 6.143.256 6.042.819 5.94 4.25 22.783 18.073 15.309c4.198 3.584 8.806 6.554 13.722 9.011l7.577 3.175 22.58 7.936 22.732-7.936a65.473 65.473 0 0014.695-7.27l6.656-4.916 17.92-15.309 4.3-22.784c.359-1.945.666-3.942.82-5.939l.307-6.093-.307-6.093-.82-5.939-4.3-22.784-17.92-15.257a67.635 67.635 0 00-13.773-9.012l-7.578-3.225-22.733-7.987zM454.144 498.739a35.84 35.84 0 014.864 71.373l-4.864.307H332.646a35.84 35.84 0 01-4.864-71.321l4.864-.359h121.498zm121.498-180.736a35.84 35.84 0 014.864 71.373l-4.864.358H332.646a35.84 35.84 0 01-4.864-71.372l4.864-.308h242.996z\"/>",
          "viewBox": "0 0 1024 1024",
          "width": "1024",
          "height": "1024"
        },
        "megui-system-change": {
          "name": "megui-system-change",
          "data": "<path pid=\"0\" d=\"M347.429 292.571q54.857 0 54.857 54.858 0 54.857-54.857 54.857-54.858 0-54.858-54.857 0-54.858 54.858-54.858zm0 164.572q54.857 0 54.857 54.857t-54.857 54.857q-54.858 0-54.858-54.857t54.858-54.857zM512 292.571q54.857 0 54.857 54.858 0 54.857-54.857 54.857t-54.857-54.857q0-54.858 54.857-54.858zm0 164.572q54.857 0 54.857 54.857T512 566.857q-54.857 0-54.857-54.857T512 457.143zm164.571-164.572q54.858 0 54.858 54.858 0 54.857-54.858 54.857-54.857 0-54.857-54.857 0-54.858 54.857-54.858zm0 164.572q54.858 0 54.858 54.857t-54.858 54.857q-54.857 0-54.857-54.857t54.857-54.857zM347.429 621.714q54.857 0 54.857 54.857 0 54.858-54.857 54.858-54.858 0-54.858-54.858 0-54.857 54.858-54.857zm164.571 0q54.857 0 54.857 54.857 0 54.858-54.857 54.858t-54.857-54.858q0-54.857 54.857-54.857zm164.571 0q54.858 0 54.858 54.857 0 54.858-54.858 54.858-54.857 0-54.857-54.858 0-54.857 54.857-54.857z\"/>",
          "viewBox": "0 0 1024 1024",
          "width": "1024",
          "height": "1024"
        },
        "megui-bell": {
          "name": "megui-bell",
          "data": "<path pid=\"0\" d=\"M12.5 22c1.09 0 1.97-.828 1.97-1.851h-3.94c0 1.023.881 1.851 1.97 1.851zm8.207-4.381l-1.277-1.2v-5.582c0-3.116-2.336-5.72-5.445-6.353V3.395C13.985 2.623 13.322 2 12.5 2c-.821 0-1.485.623-1.485 1.395v1.089c-3.108.632-5.444 3.237-5.444 6.353v5.582l-1.278 1.2c-.623.586-.188 1.59.693 1.59h15.018c.89 0 1.327-1.004.703-1.59zM12.5 13.628c.547 0 .99.416.99.93s-.443.93-.99.93c-.547 0-.99-.416-.99-.93s.443-.93.99-.93zm0-5.581c.545 0 .99.418.99.93v1.86c0 .512-.445.93-.99.93-.544 0-.99-.418-.99-.93v-1.86c0-.512.446-.93.99-.93z\" _fill=\"#E23838\" fill-rule=\"nonzero\"/>",
          "viewBox": "0 0 24 24",
          "width": "24",
          "height": "24"
        },
        "API": {
          "name": "API",
          "data": "<g fill-rule=\"nonzero\" _fill=\"none\"><path pid=\"0\" fill-opacity=\".01\" _fill=\"#FFF\" d=\"M0 0h16v16H0z\"/><path pid=\"1\" d=\"M8.242 3.242l-1 1a.6.6 0 000 .849l3.667 3.667a.6.6 0 00.849 0l1-1c1.038-1.039 1.359-3.156 0-4.516-1.36-1.359-3.477-1.038-4.516 0zm3.778.97c.693.833.476 2.11-.11 2.697l-.577.576-2.819-2.819.577-.575c.616-.616 1.993-.825 2.818 0l.11.121z\" _fill=\"#1A1A20\"/><path pid=\"2\" d=\"M13.576 1.576a.6.6 0 01.918.765l-.07.083-1.666 1.667a.6.6 0 01-.918-.765l.07-.084 1.666-1.666zM4.242 7.242l-1 1c-1.038 1.039-1.359 3.156 0 4.516 1.36 1.359 3.477 1.038 4.516 0l1-1a.6.6 0 000-.849L5.09 7.242a.6.6 0 00-.849 0zm.424 1.272l2.819 2.819-.576.576c-.616.616-1.993.825-2.818 0s-.616-2.202 0-2.818l.575-.577z\" _fill=\"#1A1A20\"/><path pid=\"3\" d=\"M8.576 8.91a.6.6 0 01.918.764l-.07.084-1.333 1.333a.6.6 0 01-.918-.765l.07-.084L8.575 8.91zM3.242 11.91a.6.6 0 01.918.764l-.07.084-1.666 1.666a.6.6 0 01-.918-.765l.07-.083 1.666-1.667zM6.242 6.576a.6.6 0 01.918.765l-.07.083-1.332 1.334a.6.6 0 01-.918-.766l.07-.083 1.332-1.333z\" _fill=\"#1A1A20\"/></g>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "Time": {
          "name": "Time",
          "data": "<g _fill=\"#979797\" fill-rule=\"nonzero\"><path pid=\"0\" d=\"M11.5 2a2 2 0 012 2v7a2 2 0 01-2 2h-9a2 2 0 01-2-2V4a2 2 0 012-2h9zm0 1h-9a1 1 0 00-.993.883L1.5 4v7a1 1 0 00.883.993L2.5 12h9a1 1 0 00.993-.883L12.5 11V4a1 1 0 00-.883-.993L11.5 3z\"/><path pid=\"1\" d=\"M4 .5a.5.5 0 01.492.41L4.5 1v3a.5.5 0 01-.992.09L3.5 4V1A.5.5 0 014 .5zM10 .5a.5.5 0 01.492.41L10.5 1v3a.5.5 0 01-.992.09L9.5 4V1a.5.5 0 01.5-.5zM13 6a.5.5 0 01.09.992L13 7H1a.5.5 0 01-.09-.992L1 6h12z\"/></g>",
          "viewBox": "0 0 14 13",
          "width": "14",
          "height": "13"
        },
        "help": {
          "name": "help",
          "data": "<path pid=\"0\" d=\"M7 0a7 7 0 110 14A7 7 0 017 0zm0 5.833a.583.583 0 00-.583.584v3.906l.004.068a.583.583 0 001.162-.068V6.417l-.004-.068A.583.583 0 007 5.833zM7 3.5A.75.75 0 107 5a.75.75 0 000-1.5z\" _fill=\"#707078\" fill-rule=\"evenodd\"/>",
          "viewBox": "0 0 14 14",
          "width": "14",
          "height": "14"
        },
        "edit": {
          "name": "edit",
          "data": "<g _fill=\"#333\" fill-rule=\"nonzero\"><path pid=\"0\" d=\"M6.333 1a.5.5 0 01.09.992L6.333 2H1.667a.167.167 0 00-.159.114l-.008.053v10.666c0 .074.048.136.114.159l.053.008h10.666a.167.167 0 00.159-.114l.008-.053V7.167a.5.5 0 01.992-.09l.008.09v5.666c0 .602-.455 1.097-1.04 1.16l-.127.007H1.667a1.167 1.167 0 01-1.16-1.04L.5 12.833V2.167c0-.602.455-1.097 1.04-1.16L1.667 1h4.666z\"/><path pid=\"1\" d=\"M10.298.147l-6.652 6.66a.5.5 0 00-.146.353V9.5a.5.5 0 00.5.5h2.352a.5.5 0 00.354-.147l6.648-6.65a.5.5 0 000-.707L11.006.146a.5.5 0 00-.708 0zm.354 1.06l1.641 1.642L6.144 9H4.5V7.366l6.152-6.159z\"/></g>",
          "viewBox": "0 0 14 14",
          "width": "14",
          "height": "14"
        },
        "acquisition_time": {
          "name": "acquisition_time",
          "data": "<g _fill=\"#A3A3A6\" fill-rule=\"nonzero\"><path pid=\"0\" d=\"M6 .5a5.5 5.5 0 014.839 8.117.5.5 0 01-.88-.477 4.5 4.5 0 10-1.567 1.672.5.5 0 11.533.847A5.5 5.5 0 116 .5z\"/><path pid=\"1\" d=\"M6 2.5a.5.5 0 01.492.41L6.5 3v3a.5.5 0 01-.095.294l-.051.06-2 2a.5.5 0 01-.765-.638l.057-.07L5.5 5.792V3a.5.5 0 01.41-.492L6 2.5z\"/></g>",
          "viewBox": "0 0 12 12",
          "width": "12",
          "height": "12"
        },
        "collection_location": {
          "name": "collection_location",
          "data": "<g _fill=\"#979797\" fill-rule=\"nonzero\"><path pid=\"0\" d=\"M.5 4.5a.5.5 0 01.492.41L1 5v6a.5.5 0 01-.992.09L0 11V5a.5.5 0 01.5-.5z\"/><path pid=\"1\" d=\"M2.646 6.646a.5.5 0 01.765.638l-.057.07-1 1a.5.5 0 01-.275.14L2 8.5H1a.5.5 0 01-.09-.992L1 7.5h.792l.854-.854zM.646 3.146a.5.5 0 01.638-.057l.07.057 5 5a.5.5 0 01-.638.765l-.07-.057-5-5a.5.5 0 010-.708zM3.646.146l-2 2a.5.5 0 000 .708l5 5a.5.5 0 00.436.14l3-.5a.5.5 0 00.285-.833l-6-6.5a.5.5 0 00-.72-.015zm.339 1.075l5.019 5.437-1.833.306L2.707 2.5l1.278-1.279z\"/></g>",
          "viewBox": "0 0 11 12",
          "width": "11",
          "height": "12"
        },
        "one_screen": {
          "name": "one_screen",
          "data": "<g fill-rule=\"nonzero\" _fill=\"none\"><path pid=\"0\" fill-opacity=\".01\" _fill=\"#FFF\" d=\"M0 0h16v16H0z\"/><path pid=\"1\" d=\"M13.5 2h-11a.5.5 0 00-.5.5v11a.5.5 0 00.5.5h11a.5.5 0 00.5-.5v-11a.5.5 0 00-.5-.5zM13 3v10H3V3h10z\" _fill=\"#979797\"/><path pid=\"2\" _fill=\"#979797\" d=\"M13.5 10.5v1h-11v-1z\"/></g>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "export": {
          "name": "export",
          "data": "<g _fill=\"#1A1A20\" fill-rule=\"nonzero\"><path pid=\"0\" d=\"M13 7.4a.6.6 0 01.592.503L13.6 8v4a1.6 1.6 0 01-1.454 1.593L12 13.6H2a1.6 1.6 0 01-1.593-1.454L.4 12V8a.6.6 0 011.192-.097L1.6 8v4a.4.4 0 00.32.392L2 12.4h10a.4.4 0 00.392-.32L12.4 12V8a.6.6 0 01.6-.6z\"/><path pid=\"1\" d=\"M7 .4a.6.6 0 01.592.503L7.6 1v9a.6.6 0 01-1.192.097L6.4 10V1A.6.6 0 017 .4z\"/><path pid=\"2\" d=\"M6.576.576a.6.6 0 01.765-.07l.083.07 4 4a.6.6 0 01-.765.918l-.083-.07L7 1.85 3.424 5.424a.6.6 0 01-.765.07l-.083-.07a.6.6 0 01-.07-.765l.07-.083 4-4z\"/></g>",
          "viewBox": "0 0 14 14",
          "width": "14",
          "height": "14"
        },
        "back": {
          "name": "back",
          "data": "<g _fill=\"none\" fill-rule=\"evenodd\"><path pid=\"0\" d=\"M-5-3v16h16V-3z\"/><path pid=\"1\" d=\"M6 8.874v1.02c0 .089-.097.137-.163.083L.155 5.332a.433.433 0 010-.664L5.837.023C5.904-.031 6 .017 6 .106v1.02a.217.217 0 01-.077.166L1.385 4.999l4.538 3.71c.048.039.077.1.077.165z\" _fill=\"#181725\" opacity=\".6\"/></g>",
          "viewBox": "0 0 6 10",
          "width": "6",
          "height": "10"
        },
        "close": {
          "name": "close",
          "data": "<g _fill=\"none\" fill-rule=\"evenodd\"><path pid=\"0\" d=\"M-1.248-2h14v14h-14z\"/><path pid=\"1\" d=\"M1.252 9.5l9-9m0 9l-9-9\" _stroke=\"#767679\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></g>",
          "viewBox": "0 0 11 10",
          "width": "11",
          "height": "10"
        },
        "close_video": {
          "name": "close_video",
          "data": "<g fill-rule=\"nonzero\" _fill=\"none\"><path pid=\"0\" fill-opacity=\".01\" _fill=\"#FFF\" d=\"M0 0h16v16H0z\"/><path pid=\"1\" d=\"M11.035 3.697a.5.5 0 01.7-.095C13.111 4.65 14 6.501 14 8.298 14 11.454 11.308 14 8 14s-6-2.546-6-5.702c0-1.788.852-3.618 2.193-4.66a.5.5 0 01.614.79C3.715 5.275 3 6.812 3 8.298 3 10.888 5.233 13 8 13s5-2.111 5-4.702c0-1.49-.747-3.045-1.87-3.9a.5.5 0 01-.095-.7z\" _fill=\"#A3A3A6\"/><path pid=\"2\" d=\"M8 2a.5.5 0 01.492.41l.008.09v4.84a.5.5 0 01-.992.09L7.5 7.34V2.5A.5.5 0 018 2z\" _fill=\"#979797\"/></g>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "structure": {
          "name": "structure",
          "data": "<g _fill=\"#1A1A20\" fill-rule=\"nonzero\"><path pid=\"0\" d=\"M6 .5a3.5 3.5 0 100 7 3.5 3.5 0 000-7zm0 1a2.5 2.5 0 110 5 2.5 2.5 0 010-5zM2 7.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm0 1a.5.5 0 110 1 .5.5 0 010-1zM6 9a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm0 1a.5.5 0 110 1 .5.5 0 010-1zM10 7.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm0 1a.5.5 0 110 1 .5.5 0 010-1z\"/><path pid=\"1\" d=\"M6.5 7v2.5h-1V7zM8.354 6.146l1.5 1.5-.708.708-1.5-1.5zM3.646 6.146l.708.708-1.5 1.5-.708-.708z\"/></g>",
          "viewBox": "0 0 12 12",
          "width": "12",
          "height": "12"
        },
        "warn": {
          "name": "warn",
          "data": "<g _fill=\"#1A1A20\" fill-rule=\"nonzero\"><path pid=\"0\" d=\"M6.15.522a.5.5 0 00-.295 0L.853 2.06a.5.5 0 00-.353.478v3.153c0 3.526 2.145 6.661 5.335 7.78a.5.5 0 00.34-.002l.247-.092C9.479 12.175 11.5 9.112 11.5 5.693V2.538a.5.5 0 00-.353-.478L6.15.522zm-.148 1L10.5 2.908v2.785l-.005.273c-.103 2.903-1.85 5.462-4.43 6.477L6 12.466l-.077-.029C3.274 11.39 1.5 8.707 1.5 5.691V2.907l4.502-1.385z\"/><path pid=\"1\" d=\"M5.933 4.1a.5.5 0 01.492.41l.008.09v4.667a.5.5 0 01-.992.09l-.008-.09V4.6a.5.5 0 01.5-.5z\"/><path pid=\"2\" d=\"M3.6 7.433a.5.5 0 01-.09-.992l.09-.008h4.667a.5.5 0 01.09.992l-.09.008H3.6z\"/></g>",
          "viewBox": "0 0 12 14",
          "width": "12",
          "height": "14"
        },
        "menu_cluster": {
          "name": "menu_cluster",
          "data": "<g fill-rule=\"nonzero\" _fill=\"none\"><path pid=\"0\" fill-opacity=\".01\" _fill=\"#FFF\" d=\"M0 0h16v16H0z\"/><path pid=\"1\" d=\"M8 .9a.6.6 0 01.592.503L8.6 1.5v4.333a.6.6 0 01-1.192.098L7.4 5.833V2.131l-.057.005A5.901 5.901 0 002.104 7.78L2.1 8a5.9 5.9 0 1011.8 0 .6.6 0 011.2 0A7.1 7.1 0 118 .9z\" _fill=\"#1A1A20\"/><path pid=\"2\" d=\"M8 5.233a2.767 2.767 0 100 5.534 2.767 2.767 0 000-5.534zm0 1.2a1.567 1.567 0 110 3.134 1.567 1.567 0 010-3.134z\" _fill=\"#1A1A20\"/></g>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "list_expands": {
          "name": "list_expands",
          "data": "<g _fill=\"none\" fill-rule=\"evenodd\"><path pid=\"0\" d=\"M-3-5h16v16H-3z\"/><path pid=\"1\" d=\"M8.874 6h1.02c.089 0 .137-.097.083-.163L5.332.155a.433.433 0 00-.664 0L.023 5.837C-.031 5.904.017 6 .106 6h1.02a.217.217 0 00.166-.077l3.707-4.538 3.71 4.538c.039.048.1.077.165.077z\" _fill=\"#181725\"/></g>",
          "viewBox": "0 0 10 6",
          "width": "10",
          "height": "6"
        },
        "bread_slash": {
          "name": "bread_slash",
          "data": "<path pid=\"0\" d=\"M4.714 0h1.038L1.034 12H0z\" _fill=\"#A3A3A6\" fill-rule=\"evenodd\"/>",
          "viewBox": "0 0 6 12",
          "width": "6",
          "height": "12"
        },
        "full_screen": {
          "name": "full_screen",
          "data": "<g fill-rule=\"nonzero\" _fill=\"none\"><path pid=\"0\" fill-opacity=\".01\" _fill=\"#FFF\" d=\"M0 0h16v16H0z\"/><path pid=\"1\" d=\"M13.5 2a.5.5 0 01.492.41L14 2.5v4a.5.5 0 01-.992.09L13 6.5V3H9.5a.5.5 0 01-.492-.41L9 2.5a.5.5 0 01.41-.492L9.5 2h4zM6.5 2a.5.5 0 01.09.992L6.5 3H3v3.5a.5.5 0 01-.41.492L2.5 7a.5.5 0 01-.492-.41L2 6.5v-4a.5.5 0 01.41-.492L2.5 2h4zM13.5 9a.5.5 0 01.492.41L14 9.5v4a.5.5 0 01-.41.492L13.5 14h-4a.5.5 0 01-.09-.992L9.5 13H13V9.5a.5.5 0 01.41-.492L13.5 9zM2.5 9a.5.5 0 01.492.41L3 9.5V13h3.5a.5.5 0 01.492.41L7 13.5a.5.5 0 01-.41.492L6.5 14h-4a.5.5 0 01-.492-.41L2 13.5v-4a.5.5 0 01.5-.5z\" _fill=\"#767679\"/><path pid=\"2\" d=\"M13.146 2.146a.5.5 0 01.765.638l-.057.07-4 4a.5.5 0 01-.765-.638l.057-.07 4-4zM6.146 9.146a.5.5 0 01.765.638l-.057.07-4 4a.5.5 0 01-.765-.638l.057-.07 4-4z\" _fill=\"#767679\"/></g>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "people_manage": {
          "name": "people_manage",
          "data": "<g fill-rule=\"nonzero\" _fill=\"none\"><path pid=\"0\" fill-opacity=\".01\" _fill=\"#FFF\" d=\"M0 0h16v16H0z\"/><path pid=\"1\" d=\"M8 1.4a3.6 3.6 0 100 7.2 3.6 3.6 0 000-7.2zm0 1.2a2.4 2.4 0 110 4.8 2.4 2.4 0 010-4.8zM9.733 9.4H6.267c-1.348 0-3.028.913-3.666 1.667l-.366.475-.121.165a3.841 3.841 0 00-.047.065c-.425.616-.667 1.232-.667 1.946V14a.6.6 0 00.6.6h12a.6.6 0 00.6-.6v-.282c0-.714-.242-1.33-.667-1.946l-.356-.476-.09-.118C12.93 10.407 11.149 9.4 9.733 9.4zm-3.466 1.2h3.466c.954 0 2.282.72 2.714 1.199l.408.53.09.125.106.16c.164.266.272.521.319.786H2.629c.058-.317.202-.621.426-.946l.15-.203.281-.37c.342-.473 1.77-1.281 2.78-1.281z\" _fill=\"#1A1A20\"/></g>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "delete": {
          "name": "delete",
          "data": "<g _fill=\"#A3A3A6\" fill-rule=\"nonzero\"><path pid=\"0\" d=\"M13 2.5a.5.5 0 01.09.992L13 3.5H1a.5.5 0 01-.09-.992L1 2.5h12z\"/><path pid=\"1\" d=\"M9 .5a1.5 1.5 0 011.493 1.356L10.5 2v1a.5.5 0 01-.992.09L9.5 3V2a.5.5 0 00-.41-.492L9 1.5H5a.5.5 0 00-.492.41L4.5 2v1a.5.5 0 01-.992.09L3.5 3V2A1.5 1.5 0 014.856.507L5 .5h4zM12 4.5a.5.5 0 01.492.41L12.5 5v6.5a2.5 2.5 0 01-2.336 2.495L10 14H4a2.5 2.5 0 01-2.495-2.336L1.5 11.5V5a.5.5 0 01.992-.09L2.5 5v6.5a1.5 1.5 0 001.356 1.493L4 13h6a1.5 1.5 0 001.493-1.356l.007-.144V5a.5.5 0 01.5-.5z\"/><path pid=\"2\" d=\"M5 4.5a.5.5 0 01.492.41L5.5 5v6a.5.5 0 01-.992.09L4.5 11V5a.5.5 0 01.5-.5zM9 4.5a.5.5 0 01.492.41L9.5 5v6a.5.5 0 01-.992.09L8.5 11V5a.5.5 0 01.5-.5z\"/></g>",
          "viewBox": "0 0 14 14",
          "width": "14",
          "height": "14"
        },
        "add": {
          "name": "add",
          "data": "<g _fill=\"#A3A3A6\" fill-rule=\"nonzero\"><path pid=\"0\" d=\"M6.752.5a.5.5 0 01.492.41l.008.09v12a.5.5 0 01-.992.09L6.252 13V1a.5.5 0 01.5-.5z\"/><path pid=\"1\" d=\"M12.752 6.5a.5.5 0 01.09.992l-.09.008h-12a.5.5 0 01-.09-.992l.09-.008h12z\"/></g>",
          "viewBox": "0 0 14 14",
          "width": "14",
          "height": "14"
        },
        "four_screen": {
          "name": "four_screen",
          "data": "<g fill-rule=\"nonzero\" _fill=\"none\"><path pid=\"0\" fill-opacity=\".01\" _fill=\"#FFF\" d=\"M0 0h16v16H0z\"/><path pid=\"1\" d=\"M13.5 2H9.1a.5.5 0 00-.5.5v4.4a.5.5 0 00.5.5h4.4a.5.5 0 00.5-.5V2.5a.5.5 0 00-.5-.5zM13 3v3.4H9.6V3H13zM13.5 8.6H9.1a.5.5 0 00-.5.5v4.4a.5.5 0 00.5.5h4.4a.5.5 0 00.5-.5V9.1a.5.5 0 00-.5-.5zm-.5 1V13H9.6V9.6H13zM6.9 2H2.5a.5.5 0 00-.5.5v4.4a.5.5 0 00.5.5h4.4a.5.5 0 00.5-.5V2.5a.5.5 0 00-.5-.5zm-.5 1v3.4H3V3h3.4zM6.9 8.6H2.5a.5.5 0 00-.5.5v4.4a.5.5 0 00.5.5h4.4a.5.5 0 00.5-.5V9.1a.5.5 0 00-.5-.5zm-.5 1V13H3V9.6h3.4z\" _fill=\"#767679\"/></g>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "search": {
          "name": "search",
          "data": "<g fill-rule=\"nonzero\" _fill=\"none\"><path pid=\"0\" fill-opacity=\".01\" _fill=\"#FFF\" d=\"M0 0h16v16H0z\"/><path pid=\"1\" d=\"M7.5 2a5.5 5.5 0 110 11 5.5 5.5 0 010-11zm0 1.2a4.3 4.3 0 100 8.6 4.3 4.3 0 000-8.6z\" _fill=\"#A3A3A6\"/><path pid=\"2\" d=\"M10.576 10.576a.6.6 0 01.765-.07l.083.07 3 3a.6.6 0 01-.765.918l-.083-.07-3-3a.6.6 0 010-.848z\" _fill=\"#A3A3A6\"/></g>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "menu_retrieval": {
          "name": "menu_retrieval",
          "data": "<g _fill=\"#1A1A20\" fill-rule=\"nonzero\"><path pid=\"0\" d=\"M10.667.733c.656 0 1.195.499 1.26 1.137l.006.13v4.947a.6.6 0 01-1.192.098l-.008-.098V2a.067.067 0 00-.04-.061l-.026-.006H1.333a.067.067 0 00-.061.041L1.267 2v12c0 .028.016.051.04.061l.026.006h5.334a.6.6 0 01.097 1.192l-.097.008H1.333a1.267 1.267 0 01-1.26-1.137L.067 14V2c0-.656.498-1.195 1.137-1.26l.13-.007h9.333zm-3.344 8.59A2.6 2.6 0 1111 13a2.6 2.6 0 01-3.677-3.677zm2.829.849a1.4 1.4 0 10-1.98 1.98 1.4 1.4 0 001.98-1.98zM4.4 4a.6.6 0 01.95-.487l3 2.154a.6.6 0 01-.036.998l-3 1.846a.6.6 0 01-.914-.51zM5.6 5.17v1.757l1.319-.811L5.6 5.169z\"/><path pid=\"1\" d=\"M10.152 12.152a.6.6 0 01.765-.07l.083.07 1.414 1.414a.6.6 0 01-.765.918l-.083-.07L10.152 13a.6.6 0 010-.848z\"/></g>",
          "viewBox": "0 0 13 16",
          "width": "13",
          "height": "16"
        },
        "menu_system": {
          "name": "menu_system",
          "data": "<g fill-rule=\"nonzero\" _fill=\"none\"><path pid=\"0\" fill-opacity=\".01\" _fill=\"#FFF\" d=\"M0 0h16v16H0z\"/><path pid=\"1\" d=\"M9.248 1.302a1.4 1.4 0 01-2.496 0 .6.6 0 00-.695-.306 7.255 7.255 0 00-3.004 1.681.6.6 0 00-.166.614l.036.091a1.4 1.4 0 01-1.122 2.012l-.154.006a.6.6 0 00-.58.42 7.296 7.296 0 00-.185 3.643.6.6 0 00.645.477 1.4 1.4 0 011.21 2.295.6.6 0 00.027.803 7.265 7.265 0 003.16 1.927.6.6 0 00.742-.392 1.4 1.4 0 012.668 0 .6.6 0 00.743.392 7.264 7.264 0 003.16-1.927.6.6 0 00.026-.803 1.4 1.4 0 011.21-2.295.6.6 0 00.646-.477 7.296 7.296 0 00-.185-3.643.6.6 0 00-.483-.414l-.108-.006h-.01a1.4 1.4 0 01-1.318-1.872l.062-.146a.6.6 0 00-.13-.705A7.255 7.255 0 009.943.997a.6.6 0 00-.695.305zm.786.982l.201.074c.5.198.97.462 1.4.784l.196.156-.03.11a2.607 2.607 0 00-.068.592l.005.164a2.601 2.601 0 002.11 2.39l.045.007.05.211c.082.4.124.811.124 1.228l-.008.31a6.116 6.116 0 01-.023.307l-.018.135-.01.002a2.6 2.6 0 00-2.275 2.58l.008.205c.027.34.12.668.271.967l.016.027-.113.101a6.065 6.065 0 01-1.59.972l-.107.04-.04-.066A2.6 2.6 0 008 12.4l-.179.006a2.601 2.601 0 00-2 1.174l-.04.066-.105-.04a6.066 6.066 0 01-1.591-.972l-.114-.101.017-.027c.181-.359.279-.758.279-1.173l-.005-.164a2.601 2.601 0 00-2.103-2.39l-.178-.027-.017-.135A6.146 6.146 0 011.934 8l.007-.311c.016-.31.055-.617.117-.917l.048-.211.045-.006A2.6 2.6 0 004.267 4l-.008-.2a2.598 2.598 0 00-.06-.393l-.031-.109.197-.156c.43-.322.9-.586 1.4-.784l.2-.074.01.015a2.598 2.598 0 003.933.134l.126-.149z\" _fill=\"#1A1A20\"/><path pid=\"2\" d=\"M8 5.067a2.933 2.933 0 100 5.866 2.933 2.933 0 000-5.866zm0 1.2a1.733 1.733 0 110 3.466 1.733 1.733 0 010-3.466z\" _fill=\"#1A1A20\"/></g>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "menu_resource": {
          "name": "menu_resource",
          "data": "<g _fill=\"#767679\" fill-rule=\"nonzero\"><path pid=\"0\" d=\"M6 1.4H3A1.6 1.6 0 001.4 3v3A1.6 1.6 0 003 7.6h3A1.6 1.6 0 007.6 6V3A1.6 1.6 0 006 1.4zM3 2.6h3c.22 0 .4.18.4.4v3a.4.4 0 01-.4.4H3a.4.4 0 01-.4-.4V3c0-.22.18-.4.4-.4zM6 8.4H3A1.6 1.6 0 001.4 10v3A1.6 1.6 0 003 14.6h3A1.6 1.6 0 007.6 13v-3A1.6 1.6 0 006 8.4zM3 9.6h3c.22 0 .4.18.4.4v3a.4.4 0 01-.4.4H3a.4.4 0 01-.4-.4v-3c0-.22.18-.4.4-.4zM13 1.4h-3A1.6 1.6 0 008.4 3v3A1.6 1.6 0 0010 7.6h3A1.6 1.6 0 0014.6 6V3A1.6 1.6 0 0013 1.4zm-3 1.2h3c.22 0 .4.18.4.4v3a.4.4 0 01-.4.4h-3a.4.4 0 01-.4-.4V3c0-.22.18-.4.4-.4zM13 8.4h-3A1.6 1.6 0 008.4 10v3a1.6 1.6 0 001.6 1.6h3a1.6 1.6 0 001.6-1.6v-3A1.6 1.6 0 0013 8.4zm-3 1.2h3c.22 0 .4.18.4.4v3a.4.4 0 01-.4.4h-3a.4.4 0 01-.4-.4v-3c0-.22.18-.4.4-.4z\"/></g>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "menu_record": {
          "name": "menu_record",
          "data": "<g _fill=\"#767679\" fill-rule=\"nonzero\"><path pid=\"0\" d=\"M8 .733a5.6 5.6 0 100 11.2 5.6 5.6 0 000-11.2zm0 1.2a4.4 4.4 0 110 8.8 4.4 4.4 0 010-8.8z\"/><path pid=\"1\" d=\"M8 3.733a2.6 2.6 0 100 5.2 2.6 2.6 0 000-5.2zm0 1.2a1.4 1.4 0 110 2.8 1.4 1.4 0 010-2.8zM9.535 10.733H6.456a.6.6 0 00-.568.409l-1.123 3.333a.6.6 0 00.568.792h5.334a.6.6 0 00.568-.793l-1.132-3.334a.6.6 0 00-.568-.407zm-.431 1.2l.725 2.133H6.168l.718-2.133h2.218z\"/><path pid=\"2\" d=\"M12 14.067a.6.6 0 01.097 1.192l-.097.008H4a.6.6 0 01-.097-1.192L4 14.067h8z\"/></g>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "menu_task": {
          "name": "menu_task",
          "data": "<g _fill=\"#767679\" fill-rule=\"nonzero\"><path pid=\"0\" d=\"M13.333 10.4a.6.6 0 01.592.503l.008.097v3c0 .656-.498 1.195-1.137 1.26l-.13.007H10.5a.6.6 0 01-.097-1.192l.097-.008h2.167a.067.067 0 00.061-.041l.005-.026v-3a.6.6 0 01.6-.6zM12.667.733c.656 0 1.195.499 1.26 1.137l.006.13v3.333a.6.6 0 01-1.192.098l-.008-.098V2a.067.067 0 00-.04-.061l-.026-.006H3.333a.067.067 0 00-.061.041L3.267 2v12c0 .028.016.051.04.061l.026.006h2a.6.6 0 01.098 1.192l-.098.008h-2a1.267 1.267 0 01-1.26-1.137L2.067 14V2c0-.656.498-1.195 1.137-1.26l.13-.007h9.333z\"/><path pid=\"1\" d=\"M10 4.733a.6.6 0 01.097 1.192L10 5.933H5.333a.6.6 0 01-.097-1.192l.097-.008H10zM12.867 7.29a.6.6 0 01.993.664l-.06.09-5.667 7a.6.6 0 01-.993-.665l.06-.09 5.667-7zM8 7.4a.6.6 0 01.097 1.192L8 8.6H5.333a.6.6 0 01-.097-1.192l.097-.008H8z\"/></g>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "menu_monitor": {
          "name": "menu_monitor",
          "data": "<g _fill=\"#767679\" fill-rule=\"evenodd\"><path pid=\"0\" d=\"M3.267 2.667v5.452c0 2.545 2.116 4.614 4.733 4.614 2.544 0 4.615-1.955 4.728-4.403l.005-.211V2.667h1.2v5.452c0 3.214-2.66 5.814-5.933 5.814-3.2 0-5.812-2.483-5.93-5.596l-.003-.218V2.667h1.2z\"/><path pid=\"1\" d=\"M15.111 2.117a.6.6 0 01.097 1.192l-.097.008H.89a.6.6 0 01-.097-1.192l.097-.008H15.11zM8 6.067a2.378 2.378 0 100 4.755 2.378 2.378 0 000-4.755zm0 1.2a1.178 1.178 0 110 2.355 1.178 1.178 0 010-2.355z\"/></g>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "menu_down": {
          "name": "menu_down",
          "data": "<path pid=\"0\" d=\"M11.874 5h1.02c.089 0 .137.097.083.163l-4.645 5.682a.433.433 0 01-.664 0L3.023 5.163C2.969 5.096 3.017 5 3.106 5h1.02c.064 0 .126.029.166.077l3.707 4.538 3.71-4.538A.217.217 0 0111.873 5z\" _fill=\"#767679\" fill-rule=\"evenodd\"/>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "test": {
          "name": "test",
          "data": "<defs><filter color-interpolation-filters=\"auto\" id=\"svgicon_iconTest_a\"><feColorMatrix in=\"SourceGraphic\" values=\"0 0 0 0 0.462745 0 0 0 0 0.462745 0 0 0 0 0.474510 0 0 0 1.000000 0\"/></filter></defs><g transform=\"translate(-12 -8)\" filter=\"url(#svgicon_iconTest_a)\" _fill=\"none\" fill-rule=\"evenodd\"><g _fill=\"#767679\" fill-rule=\"nonzero\"><path pid=\"0\" d=\"M24 10.286h-8c-.947 0-1.714.767-1.714 1.714v9.143c0 .425.447.7.827.511l1.816-.908c.079-.04.166-.06.255-.06H24c.947 0 1.714-.768 1.714-1.715V12c0-.947-.767-1.714-1.714-1.714zm-8 1.143h8c.316 0 .571.255.571.571v6.971a.571.571 0 01-.571.572h-6.816l-.159.007c-.211.02-.417.079-.608.174l-.988.493V12c0-.316.255-.571.571-.571z\"/><path pid=\"1\" d=\"M22.065 13.745a.571.571 0 01.874.728l-.066.08-3.086 3.085a.572.572 0 01-.73.066l-.078-.066-1.852-1.851a.571.571 0 01.73-.874l.078.066 1.448 1.447 2.682-2.681z\"/></g></g>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "password": {
          "name": "password",
          "data": "<g _fill=\"#767679\" fill-rule=\"nonzero\"><path pid=\"0\" d=\"M10 5.5H4A1.5 1.5 0 002.5 7v4A1.5 1.5 0 004 12.5h6a1.5 1.5 0 001.5-1.5V7A1.5 1.5 0 0010 5.5zm-6 1h6a.5.5 0 01.5.5v4a.5.5 0 01-.5.5H4a.5.5 0 01-.5-.5V7a.5.5 0 01.5-.5z\"/><path pid=\"1\" d=\"M7 1.5c1.86 0 3.395 1.363 3.495 3.097l.005.18V5.5a.5.5 0 01-.992.09L9.5 5.5v-.722C9.5 3.528 8.389 2.5 7 2.5c-1.331 0-2.407.945-2.494 2.123l-.006.155V5.5a.5.5 0 01-.992.09L3.5 5.5v-.722C3.5 2.958 5.075 1.5 7 1.5zM7 7.5a.5.5 0 01.492.41L7.5 8v2a.5.5 0 01-.992.09L6.5 10V8a.5.5 0 01.5-.5z\"/></g>",
          "viewBox": "0 0 14 14",
          "width": "14",
          "height": "14"
        },
        "person_name": {
          "name": "person_name",
          "data": "<path pid=\"0\" d=\"M7.05 1.124c2 0 3.192 1.138 3.192 3.043l-.003.316-.01.273c-.05.977-.305 2.57-1.598 3.477l-.005.229c1.818.247 3.638.97 3.638 2.074.003 1.552-1.77 2.338-5.265 2.338-3.495 0-5.268-.786-5.268-2.336 0-1.105 1.827-1.832 3.645-2.076v-.23c-1.093-.765-1.625-2.099-1.625-4.065 0-1.839 1.112-2.963 2.987-3.039l.313-.004zm0 1h-.108c-1.456 0-2.191.701-2.191 2.043 0 1.67.409 2.693 1.198 3.244a1 1 0 01.42.699l.007.121v.23a1 1 0 01-.867.992c-.848.114-1.636.335-2.181.614-.436.223-.597.407-.597.471 0 .775 1.264 1.336 4.268 1.336 3.004 0 4.267-.56 4.265-1.338 0-.064-.16-.246-.593-.468-.543-.279-1.33-.5-2.18-.615a1 1 0 01-.86-.896l-.005-.116.005-.228a1 1 0 01.332-.724l.093-.074c.8-.562 1.13-1.539 1.179-2.8l.006-.256v-.192c0-1.284-.671-1.98-2.005-2.039l-.185-.004z\" _fill=\"#767679\" fill-rule=\"nonzero\"/>",
          "viewBox": "0 0 14 14",
          "width": "14",
          "height": "14"
        },
        "user": {
          "name": "user",
          "data": "<defs><filter color-interpolation-filters=\"auto\" id=\"svgicon_user_a\"><feColorMatrix in=\"SourceGraphic\" values=\"0 0 0 0 0.972549 0 0 0 0 0.972549 0 0 0 0 0.972549 0 0 0 1.000000 0\"/></filter></defs><g transform=\"translate(-1284 -15)\" filter=\"url(#svgicon_user_a)\" _fill=\"none\" fill-rule=\"evenodd\"><g _fill=\"#767679\" fill-rule=\"nonzero\"><path pid=\"0\" d=\"M1295.143 29.348l.014.029-.06-.171c-.03-.15-.033-.384 0-.747.083-.908.38-1.462 1.037-2.216l.321-.36.099-.115.07-.092c.14-.196.238-.425.299-.666l.02-.086.033-.188a.524.524 0 00.003-.03l-.002-.036-.128-.137-.057-.093a.687.687 0 01-.06-.442c.036-.23.056-.417.066-.594.021-.385.02-.717-.017-1.039l-.045-.301-.034-.148a1.673 1.673 0 00-.327-.653l-.033-.033-.103-.083a3.161 3.161 0 00-.485-.28c-.616-.294-1.442-.508-2.508-.587l-.117-.008-.244-.006-.281.005-.397.018.016.069a.67.67 0 01-.002.196l-.024.102-.07.154a1.643 1.643 0 01-.368.388c-.2.17-.423.464-.492.812l-.02.152c-.085.492-.076 1.288.023 1.806.039.197.045.3-.047.493a.6.6 0 01-.086.13l-.11.105.004.095.02.116.025.104c.061.24.16.469.3.665l.07.092.098.115.149.166c.778.858 1.12 1.427 1.209 2.41l.02.28c.007.168.004.298-.008.397l-.011.07-.061.171.013-.03-.016.047c-.132.302-.514.534-1.204.73l-.196.054c-.166.042-.338.08-.512.115l-.372.067-.233.035c-.604.102-1.104.28-1.485.52-.26.165-.81.76-.989 1.06a.6.6 0 01-1.03-.616c.271-.453.947-1.186 1.379-1.459.525-.331 1.173-.56 1.94-.69l.223-.034.1-.017c.233-.04.466-.089.681-.144.2-.051.358-.1.478-.147l.106-.045-.018-.255c-.055-.601-.25-.968-.756-1.548l-.325-.364-.126-.148-.102-.136a3.122 3.122 0 01-.578-1.651c0-.254.058-.456.167-.632l.07-.102-.003-.02a7.357 7.357 0 01-.027-1.736l.03-.201c.034-.703.395-1.254.816-1.648l.091-.082-.01-.08a1.037 1.037 0 010-.135l.02-.142c.072-.367.34-.68.796-.8.14-.035.247-.046.427-.055l.385-.017.321-.005c.15 0 .288.006.432.017 2.112.157 3.361.756 3.937 1.382.273.318.469.699.587 1.136.025.09.044.173.057.245l.016.098c.085.481.095.96.064 1.526-.006.109-.015.22-.028.337l-.02.161.013.015c.044.061.081.125.114.2l.044.12c.042.127.06.259.06.43a3.12 3.12 0 01-.578 1.64l-.102.135-.126.149-.179.2c-.616.679-.842 1.055-.902 1.71l-.019.256.026.012.18.07.113.036.27.075c.144.037.294.07.447.1l.36.065.204.03c.768.139 1.418.373 1.944.706.432.274 1.097.994 1.365 1.442a.6.6 0 11-1.03.615c-.177-.295-.714-.877-.977-1.044-.385-.243-.89-.425-1.485-.533l-.316-.047-.387-.074a9.744 9.744 0 01-.422-.097c-.821-.21-1.268-.457-1.408-.79l-.014-.041z\"/><path pid=\"1\" d=\"M1294 15c5.523 0 10 4.477 10 10s-4.477 10-10 10-10-4.477-10-10 4.477-10 10-10zm0 1.2a8.8 8.8 0 100 17.6 8.8 8.8 0 000-17.6z\"/></g></g>",
          "viewBox": "0 0 20 20",
          "width": "20",
          "height": "20"
        },
        "tips": {
          "name": "tips",
          "data": "<g _fill=\"#767679\" fill-rule=\"evenodd\"><path pid=\"0\" d=\"M8 4.5c.3 0 .546.2.58.458l.003.06v3.63c0 .287-.26.519-.583.519-.3 0-.546-.2-.58-.458l-.003-.06v-3.63c0-.287.26-.519.583-.519z\" fill-rule=\"nonzero\"/><path pid=\"1\" d=\"M8 11.55A.875.875 0 108 9.8a.875.875 0 000 1.75z\"/><path pid=\"2\" d=\"M8 1a7 7 0 110 14A7 7 0 018 1zm0 1a6 6 0 100 12A6 6 0 008 2z\" fill-rule=\"nonzero\"/></g>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "person_upload": {
          "name": "person_upload",
          "data": "<defs><rect pid=\"0\" id=\"svgicon_person_upload_a\" x=\"0\" y=\"0\" width=\"48\" height=\"48\" rx=\"4\"/></defs><g transform=\"translate(4 4)\" _fill=\"none\" fill-rule=\"evenodd\"><mask id=\"svgicon_person_upload_b\" _fill=\"#fff\"><use xlink:href=\"#svgicon_person_upload_a\"/></mask><use _fill=\"#E8E8E8\" xlink:href=\"#svgicon_person_upload_a\"/><path pid=\"1\" d=\"M1.022 54.316h45.77A1.406 1.406 0 0048 52.19a6.086 6.086 0 00-3.65-2.766l-6.743-1.815a7.033 7.033 0 01-4.765-4.341l-.671-1.806a9.452 9.452 0 01-.592-3.293c0-1.127.156-2.25.463-3.334l.964-3.406a2.148 2.148 0 011.1-1.332c.53-.269.909-.767 1.025-1.35l.486-2.456a2.003 2.003 0 00-.354-1.58 2.082 2.082 0 01-.379-1.585l.493-2.914a6.73 6.73 0 00-.85-4.561l-.369-.62a11.842 11.842 0 01-1.316-3.204 4.238 4.238 0 00-1.919-2.607l-.607-.367a8.817 8.817 0 00-4.567-1.275h-2.748c-2.119 0-4.215.434-6.159 1.275a7.524 7.524 0 00-4.066 4.284l-.144.39a15.298 15.298 0 00-.867 7.003l.342 3.106a1.36 1.36 0 01-.739 1.362 1.095 1.095 0 00-.546 1.32l1.124 3.404c.158.477.604.8 1.107.8.51 0 .971.305 1.17.775l1.534 3.609a8.35 8.35 0 01.664 3.263c0 1.118-.258 2.221-.755 3.223l-.93 1.876a8.405 8.405 0 01-5.346 4.385l-6.762 1.82a4.552 4.552 0 00-3.05 2.717 1.552 1.552 0 001.444 2.125z\" _fill=\"#FFF\" mask=\"url(#svgicon_person_upload_b)\"/></g>",
          "viewBox": "0 0 56 56",
          "width": "56",
          "height": "56"
        },
        "drag": {
          "name": "drag",
          "data": "<g _fill=\"#767679\" fill-rule=\"evenodd\"><circle pid=\"0\" cx=\"4\" cy=\"6\" r=\"1\"/><circle pid=\"1\" cx=\"4\" cy=\"10\" r=\"1\"/><circle pid=\"2\" cx=\"8\" cy=\"6\" r=\"1\"/><circle pid=\"3\" cx=\"8\" cy=\"10\" r=\"1\"/><circle pid=\"4\" cx=\"12\" cy=\"6\" r=\"1\"/><circle pid=\"5\" cx=\"12\" cy=\"10\" r=\"1\"/></g>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "exit-fullscreen": {
          "name": "exit-fullscreen",
          "data": "<g _fill=\"#767679\" fill-rule=\"nonzero\"><path pid=\"0\" d=\"M6.5 9a.5.5 0 01.492.41L7 9.5v4a.5.5 0 01-.992.09L6 13.5V10H2.5a.5.5 0 01-.492-.41L2 9.5a.5.5 0 01.41-.492L2.5 9h4zM4.5 2a.5.5 0 01.09.992L4.5 3H3v1.5a.5.5 0 01-.41.492L2.5 5a.5.5 0 01-.492-.41L2 4.5v-2a.5.5 0 01.41-.492L2.5 2h2zM13.5 11a.5.5 0 01.492.41l.008.09v2a.5.5 0 01-.41.492L13.5 14h-2a.5.5 0 01-.09-.992L11.5 13H13v-1.5a.5.5 0 01.41-.492L13.5 11zM9.5 2a.5.5 0 01.492.41L10 2.5V6h3.5a.5.5 0 01.492.41L14 6.5a.5.5 0 01-.41.492L13.5 7h-4a.5.5 0 01-.492-.41L9 6.5v-4a.5.5 0 01.5-.5z\"/><path pid=\"1\" d=\"M13.146 2.146a.5.5 0 01.765.638l-.057.07-4 4a.5.5 0 01-.765-.638l.057-.07 4-4zM6.146 9.146a.5.5 0 01.765.638l-.057.07-4 4a.5.5 0 01-.765-.638l.057-.07 4-4z\"/></g>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "help_document": {
          "name": "help_document",
          "data": "<g _fill=\"#FFF\" fill-rule=\"evenodd\"><path pid=\"0\" d=\"M10 0c5.523 0 10 4.477 10 10s-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0zm0 1.2a8.8 8.8 0 100 17.6 8.8 8.8 0 000-17.6z\" fill-rule=\"nonzero\"/><path pid=\"1\" fill-opacity=\".01\" fill-rule=\"nonzero\" d=\"M0 0h20v20H0z\"/><path pid=\"2\" d=\"M10 4.56a3.2 3.2 0 01.886 6.276l-.186.047v1.044a.7.7 0 01-.605.694l-.095.006a.7.7 0 01-.694-.605l-.006-.095V10.26a.7.7 0 01.605-.693L10 9.56a1.8 1.8 0 10-1.8-1.8.7.7 0 01-1.4 0 3.2 3.2 0 013.2-3.2z\" fill-rule=\"nonzero\"/><path pid=\"3\" d=\"M10 15.677a1.042 1.042 0 100-2.083 1.042 1.042 0 000 2.083z\"/></g>",
          "viewBox": "0 0 20 20",
          "width": "20",
          "height": "20"
        },
        "close_videos": {
          "name": "close_videos",
          "data": "<defs><filter color-interpolation-filters=\"auto\" id=\"svgicon_close_videos_a\"><feColorMatrix in=\"SourceGraphic\" values=\"0 0 0 0 0.462745 0 0 0 0 0.462745 0 0 0 0 0.474510 0 0 0 1.000000 0\"/></filter></defs><g transform=\"translate(-84)\" filter=\"url(#svgicon_close_videos_a)\" _fill=\"none\" fill-rule=\"evenodd\"><g _fill=\"#767679\" fill-rule=\"nonzero\"><path pid=\"0\" d=\"M92 1.4a.6.6 0 01.592.503L92.6 2v5a.6.6 0 01-1.192.097L91.4 7V2a.6.6 0 01.6-.6z\"/><path pid=\"1\" d=\"M88.019 3.642a.533.533 0 01.77.048c.2.233.18.59-.046.797a5.146 5.146 0 00-1.652 3.802c0 2.807 2.198 5.082 4.909 5.082s4.91-2.275 4.91-5.082c0-1.451-.591-2.803-1.608-3.76a.579.579 0 01-.037-.798.533.533 0 01.77-.038A6.295 6.295 0 0198 8.29c0 3.43-2.686 6.211-6 6.211s-6-2.78-6-6.21c0-1.8.744-3.477 2.019-4.648z\"/></g></g>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "close_video2": {
          "name": "close_video2",
          "data": "<defs><filter color-interpolation-filters=\"auto\" id=\"svgicon_close_video2_a\"><feColorMatrix in=\"SourceGraphic\" values=\"0 0 0 0 0.945098 0 0 0 0 0.945098 0 0 0 0 0.949020 0 0 0 1.000000 0\"/></filter></defs><g transform=\"translate(-916 -160)\" filter=\"url(#svgicon_close_video2_a)\" _fill=\"none\" fill-rule=\"evenodd\"><g _fill=\"#767679\" fill-rule=\"nonzero\"><path pid=\"0\" d=\"M924 161.4a.6.6 0 01.592.503l.008.097v5a.6.6 0 01-1.192.097L923.4 167v-5a.6.6 0 01.6-.6z\"/><path pid=\"1\" d=\"M920.019 163.642a.533.533 0 01.77.048c.2.233.18.59-.046.797a5.146 5.146 0 00-1.652 3.802c0 2.807 2.198 5.082 4.909 5.082s4.91-2.275 4.91-5.082c0-1.451-.591-2.803-1.608-3.76a.579.579 0 01-.037-.798.533.533 0 01.77-.038A6.295 6.295 0 01930 168.29c0 3.43-2.686 6.211-6 6.211s-6-2.78-6-6.21c0-1.8.744-3.477 2.019-4.648z\"/></g></g>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "device": {
          "name": "device",
          "data": "<g _fill=\"#48484D\" fill-rule=\"nonzero\"><path pid=\"0\" d=\"M2.857 6.857c.28 0 .514.173.562.402l.01.088v5.877c0 .271-.256.49-.572.49-.28 0-.514-.173-.562-.401l-.01-.089V7.347c0-.27.257-.49.572-.49z\"/><path pid=\"1\" d=\"M5.31 8.739a.571.571 0 01.874.729l-.066.079-1.143 1.143a.571.571 0 01-.314.16l-.09.007H3.43a.571.571 0 01-.103-1.134l.103-.009h.905l.976-.975zM3.025 4.739a.572.572 0 01.728-.066l.08.066 5.714 5.714a.571.571 0 01-.73.874l-.078-.066-5.714-5.714a.571.571 0 010-.808zM6.453 1.31L4.167 3.596a.571.571 0 000 .808l5.715 5.714c.13.13.316.19.498.16l3.428-.571a.571.571 0 00.326-.952L7.277 1.327a.571.571 0 00-.824-.017zm.387 1.228l5.736 6.214-2.095.35L5.38 4 6.84 2.538z\"/></g>",
          "viewBox": "0 0 16 16",
          "width": "16",
          "height": "16"
        },
        "cancel": {
          "name": "cancel",
          "data": "<path pid=\"0\" d=\"M12 2C6.478 2 2 6.478 2 12s4.478 10 10 10 10-4.478 10-10S17.522 2 12 2zm3.692 13.8l-1.473-.008L12 13.147 9.783 15.79l-1.475.007a.178.178 0 01-.179-.179c0-.042.016-.082.043-.116l2.904-3.46-2.904-3.457a.18.18 0 01.136-.295l1.475.007L12 10.942l2.217-2.643 1.473-.007c.098 0 .178.079.178.179a.186.186 0 01-.042.116l-2.9 3.458 2.902 3.46a.18.18 0 01-.136.295z\" _fill=\"#74747C\" fill-rule=\"evenodd\"/>",
          "viewBox": "0 0 24 24",
          "width": "24",
          "height": "24"
        },
        "file": {
          "name": "file",
          "data": "<path pid=\"0\" d=\"M8.667.4a.6.6 0 01.424.176l2 2a.6.6 0 01.176.424v10a.6.6 0 01-.6.6H1.333a.6.6 0 01-.6-.6V1a.6.6 0 01.6-.6zM7.399 1.599L1.933 1.6v10.8h8.134V4.266H8a.6.6 0 01-.595-.524L7.4 3.667V1.599zM8 8.4a.6.6 0 01.075 1.195L8 9.6H4a.6.6 0 01-.075-1.195L4 8.4h4zm0-2.667a.6.6 0 01.075 1.196L8 6.933H4a.6.6 0 01-.075-1.195L4 5.733h4zm1.884-2.667L8.6 1.781 8.6 3.067l1.284-.001z\" _fill=\"#48484D\" fill-rule=\"nonzero\"/>",
          "viewBox": "0 0 12 14",
          "width": "12",
          "height": "14"
        }
      }; // will be replaced with loader

      var SvgIcons = $$$;

      if (opts.svgIcons) {
        // local svg data
        SvgIcons = _objectSpread(_objectSpread({}, SvgIcons), opts.svgIcons);
      }

      SvgIcon.register(SvgIcons);
      Vue.use(SvgIcon, _objectSpread(_objectSpread({}, {
        classPrefix: 'meg',
        tagName: 'meg-icon'
      }), opts));
    }
  };
  /* harmony default export */

  var src = __webpack_exports__["default"] = VueIconPlugin;
  /***/
}
/******/
]);